/* Sans Armure — motion. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Reveal on scroll */
  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Header turns to glass after the hero */
  function initHeader() {
    var header = document.querySelector('[data-header].sa-header--float');
    if (!header) return;
    var tick = false;
    function update() {
      tick = false;
      header.classList.toggle('is-scrolled', window.scrollY > window.innerHeight * 0.55);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Story lights up word by word */
  var wordBlocks = [];
  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var span = document.createElement('span');
        span.className = 'sa-word';
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
    wordBlocks.push({ el: el, words: el.querySelectorAll('.sa-word') });
  }
  function updateWords() {
    var vh = window.innerHeight;
    wordBlocks.forEach(function (b) {
      var r = b.el.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.35;
      var p = (start - r.top) / ((start - end) + r.height * 0.6);
      p = Math.max(0, Math.min(1, p));
      var lit = Math.round(p * b.words.length);
      for (var i = 0; i < b.words.length; i++) b.words[i].classList.toggle('is-lit', i < lit);
    });
  }
  function initWords(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-words]').forEach(splitWords);
    updateWords();
  }
  var wordTick = false;
  window.addEventListener('scroll', function () {
    if (!wordBlocks.length || wordTick) return;
    wordTick = true;
    requestAnimationFrame(function () { wordTick = false; updateWords(); });
  }, { passive: true });
  window.addEventListener('resize', updateWords);

  /* Jacket stage: drag to spin in 3D, front/back buttons, gentle auto-turn, pointer tilt */
  function initStage(root) {
    (root || document).querySelectorAll('[data-stage]').forEach(function (stage) {
      if (stage.dataset.ready) return;
      stage.dataset.ready = '1';
      var buttons = stage.querySelectorAll('[data-view]');
      var faces = stage.querySelectorAll('[data-face]');
      var spinEl = stage.querySelector('[data-tilt]');
      var angle = 0, target = 0, timer = null, touched = false, anim = null;
      var dragging = false, startX = 0, startAngle = 0, lastX = 0, lastT = 0, vel = 0, moved = 0;

      function norm(d) { d = ((d % 360) + 360) % 360; return d > 180 ? d - 360 : d; }
      function setAngle(a) {
        angle = a;
        var best = null, bestAbs = 999;
        faces.forEach(function (f) {
          var rel = norm(a - (parseFloat(f.dataset.angle) || 0)), ab = Math.abs(rel);
          if (ab < bestAbs) { bestAbs = ab; best = f; }
          var op = Math.max(0, Math.min(1, 1 - (ab - 30) / 22));
          f.style.opacity = op.toFixed(3);
          f.style.transform = op > 0 ? 'rotateY(' + (rel * 0.55).toFixed(2) + 'deg) scale(' + (1 - Math.min(ab, 60) / 600).toFixed(3) + ')' : '';
          f.style.visibility = op > 0 ? 'visible' : 'hidden';
        });
        faces.forEach(function (f) { f.classList.toggle('is-active', f === best && bestAbs < 26); });
        var view = best ? best.dataset.face : 'front';
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === view ? 'true' : 'false'); });
      }
      function tweenTo(to, ms) {
        cancelAnimationFrame(anim);
        if (reduce) { setAngle(to); return; }
        var from = angle, t0 = performance.now();
        ms = ms || 900;
        stage.classList.add('is-spinning');
        (function step(now) {
          var p = Math.min(1, (now - t0) / ms);
          var e = 1 - Math.pow(1 - p, 4);
          setAngle(from + (to - from) * e);
          if (p < 1) anim = requestAnimationFrame(step);
          else stage.classList.remove('is-spinning');
        })(t0);
      }
      function snap(a) { return Math.round(a / 90) * 90; }
      function show(view) {
        var f = stage.querySelector('[data-face="' + view + '"]'); if (!f) return;
        var target = angle + norm((parseFloat(f.dataset.angle) || 0) - angle);
        tweenTo(target, 500 + Math.abs(target - angle) * 5);
      }
      function userTurned() { touched = true; stop(); stage.classList.add('is-turned'); }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { userTurned(); show(b.dataset.view); });
      });

      function start() { if (reduce || touched || timer) return; timer = setInterval(function () { tweenTo(snap(angle) + 90, 1500); }, 4200); }
      function stop() { clearInterval(timer); timer = null; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0.35 }).observe(stage);
      }

      if (stage.hasAttribute('data-spin')) {
        stage.addEventListener('pointerdown', function (e) {
          if (e.button !== 0 || e.target.closest('button, a, input')) return;
          dragging = true; moved = 0; vel = 0;
          startX = lastX = e.clientX; lastT = performance.now();
          startAngle = angle;
          cancelAnimationFrame(anim);
          stage.classList.add('is-dragging');
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        });
        stage.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var now = performance.now();
          var dx = e.clientX - startX;
          moved = Math.max(moved, Math.abs(dx));
          if (moved > 4 && !touched) userTurned();
          var w = stage.getBoundingClientRect().width || 400;
          setAngle(startAngle + dx / w * 260);
          var dt = Math.max(1, now - lastT);
          vel = vel * 0.6 + ((e.clientX - lastX) / w * 260 / dt) * 0.4;
          lastX = e.clientX; lastT = now;
        });
        function release() {
          if (!dragging) return;
          dragging = false;
          stage.classList.remove('is-dragging');
          if (moved < 4) return;
          var projected = angle + vel * 260;
          var to = snap(projected);
          if (to === snap(startAngle) && Math.abs(angle - startAngle) > 30) to = snap(startAngle) + (angle > startAngle ? 90 : -90);
          var turns = Math.abs(to - angle) / 90;
          tweenTo(to, 600 + Math.min(turns, 4) * 260);
          if (window.saSound && Math.abs(to - startAngle) >= 90) window.saSound('turn');
        }
        stage.addEventListener('pointerup', release);
        stage.addEventListener('pointercancel', release);
        stage.addEventListener('lostpointercapture', release);
      }

      if (finePointer && !reduce && spinEl) {
        stage.addEventListener('pointermove', function (e) {
          if (dragging) return;
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          spinEl.style.setProperty('--rx', (x * 14).toFixed(2) + 'deg');
          spinEl.style.setProperty('--ry', (y * -9).toFixed(2) + 'deg');
        });
        stage.addEventListener('pointerleave', function () {
          spinEl.style.setProperty('--rx', '0deg');
          spinEl.style.setProperty('--ry', '0deg');
        });
      }
      setAngle(0);
    });
  }

  /* Optional launch countdown */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (box) {
      var target = Date.parse(box.dataset.countdown);
      if (isNaN(target)) return;
      var units = {
        days: box.querySelector('[data-unit="days"]'),
        hours: box.querySelector('[data-unit="hours"]'),
        minutes: box.querySelector('[data-unit="minutes"]'),
        seconds: box.querySelector('[data-unit="seconds"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var ms = Math.max(0, target - Date.now());
        var s = Math.floor(ms / 1000);
        units.days.textContent = pad(Math.floor(s / 86400));
        units.hours.textContent = pad(Math.floor(s % 86400 / 3600));
        units.minutes.textContent = pad(Math.floor(s % 3600 / 60));
        units.seconds.textContent = pad(s % 60);
        if (ms <= 0) clearInterval(t);
      }
      box.hidden = false;
      tick();
      var t = setInterval(tick, 1000);
    });
  }


  /* ======================================================================
     Signature motion
     ====================================================================== */

  /* Opening heartbeat plays once per session */
  function markSeen() { try { sessionStorage.setItem('sa-seen', '1'); } catch (e) {} }

  /* Scroll progress line */
  function initProgress() {
    var bar = document.querySelector('.sa-progress');
    if (!bar || reduce) return;
    var tick = false;
    function update() {
      tick = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--sp', max > 0 ? (window.scrollY / max).toFixed(4) : 0);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Live heartbeat monitor: sweeps like a bedside monitor, beats on its own,
     and quickens when someone types their email or hovers the button. */
  var monitors = [];
  function beatShape(t) {
    // t in [0,1] across one beat; returns vertical offset (-1..1)
    if (t < .10) return Math.sin(t / .10 * Math.PI) * .08;                 // P wave
    if (t < .16) return 0;
    if (t < .19) return (t - .16) / .03 * .18;                              // Q
    if (t < .23) return .18 - (t - .19) / .04 * 1.18;                       // R up
    if (t < .28) return -1 + (t - .23) / .05 * 1.45;                        // S down
    if (t < .32) return .45 - (t - .28) / .04 * .45;
    if (t < .45) return 0;
    if (t < .62) return -Math.sin((t - .45) / .17 * Math.PI) * .22;        // T wave
    return 0;
  }
  function initMonitor(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-monitor]').forEach(function (m) {
      if (m.dataset.ready) return; m.dataset.ready = '1';
      var cv = m.querySelector('canvas'); if (!cv || !cv.getContext) return;
      var ctx = cv.getContext('2d');
      var bpmEl = m.querySelector('[data-bpm]'), heart = m.querySelector('.sa-monitor__heart');
      var st = { x: 0, lastY: null, beatT: -1, beatLen: 70, since: 0, rest: 60, beats: [], visible: true };
      var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0;
      function size() {
        var r = m.getBoundingClientRect();
        W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
        cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, W, H); st.x = 0; st.lastY = null;
      }
      size(); window.addEventListener('resize', size);
      m.classList.add('is-live');
      var glow = getComputedStyle(document.documentElement).getPropertyValue('--sa-glow').trim() || '#A9C1E8';

      function trigger() {
        if (st.beatT >= 0 && st.beatT < .5) return;
        st.beatT = 0;
        var now = performance.now();
        st.beats.push(now); st.beats = st.beats.filter(function (b) { return now - b < 6000; });
        if (st.beats.length > 1) {
          var span = (st.beats[st.beats.length - 1] - st.beats[0]) / (st.beats.length - 1);
          var bpm = Math.round(Math.max(48, Math.min(180, 60000 / span)));
          if (bpmEl) bpmEl.textContent = bpm;
        }
        if (heart) { heart.classList.remove('is-beat'); void heart.offsetWidth; heart.classList.add('is-beat'); }
        if (window.saSound) window.saSound('beat');
      }
      m.saTrigger = trigger;
      monitors.push(m);

      var excite = 0;
      function frame() {
        if (!st.visible) { requestAnimationFrame(frame); return; }
        var speed = 2.2;
        for (var k = 0; k < 2; k++) {
          st.since += 1;
          var interval = (m.saInterval || 64) - excite * 26;
          if (st.since > interval) { st.since = 0; trigger(); }
          var y = 0;
          if (st.beatT >= 0) {
            y = beatShape(st.beatT);
            st.beatT += 1 / st.beatLen;
            if (st.beatT >= 1) st.beatT = -1;
          }
          var py = H / 2 - y * (H * .42);
          var nx = st.x + speed / 2;
          ctx.clearRect(st.x + 1, 0, 26, H);
          if (st.lastY !== null) {
            ctx.strokeStyle = glow; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
            ctx.shadowColor = glow; ctx.shadowBlur = 8;
            ctx.beginPath(); ctx.moveTo(st.x, st.lastY); ctx.lineTo(nx, py); ctx.stroke();
          }
          st.x = nx; st.lastY = py;
          if (st.x > W) { st.x = 0; st.lastY = null; }
        }
        // fade old trace slightly so the sweep reads as a monitor
        ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,.012)'; ctx.fillRect(0, 0, W, H); ctx.restore();
        excite = Math.max(0, excite - .004);
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { st.visible = e[0].isIntersecting; }).observe(m);

      // Typing in any email field makes the heart beat with each keystroke
      document.addEventListener('input', function (e) {
        if (e.target && e.target.type === 'email') { excite = Math.min(1, excite + .25); trigger(); }
      });
      document.querySelectorAll('.sa-signup .sa-button').forEach(function (b) {
        b.addEventListener('pointerenter', function () { excite = 1; });
      });
    });
  }

  /* Balloons: tap one to let it go */
  function initSky(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-sky]').forEach(function (sky) {
      if (sky.dataset.ready) return; sky.dataset.ready = '1';
      sky.addEventListener('pointerdown', function (e) {
        var b = e.target.closest('.sa-balloon'); if (!b || b.classList.contains('is-released')) return;
        var a = b.getAnimations ? b.getAnimations()[0] : null;
        if (a) a.playbackRate = 7;
        b.classList.add('is-released');
        monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
        setTimeout(function () { if (a) a.playbackRate = 1; b.classList.remove('is-released'); }, 3600);
      });
    });
  }

  /* Headings arrive letter by letter */
  var charIndex = 0;
  function splitInto(node, text, start) {
    var i = start;
    text.split(/(\s+)/).forEach(function (part) {
      if (!part) return;
      if (/^\s+$/.test(part)) { node.appendChild(document.createTextNode(' ')); return; }
      var w = document.createElement('span'); w.className = 'sa-word-wrap'; w.setAttribute('aria-hidden', 'true');
      for (var k = 0; k < part.length; k++) {
        var c = document.createElement('span'); c.className = 'sa-char'; c.style.setProperty('--c', i++); c.textContent = part[k]; w.appendChild(c);
      }
      node.appendChild(w);
    });
    return i;
  }
  function splitChars(el) {
    if (el.dataset.chars) return; el.dataset.chars = '1';
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var kids = Array.prototype.slice.call(el.children);
    if (kids.length && kids.every(function (k) { return k.children.length === 0; })) {
      var i = 0;
      kids.forEach(function (k) { var t = k.textContent.trim(); k.textContent = ''; i = splitInto(k, t, i); });
      return;
    }
    var text = el.textContent; el.textContent = '';
    splitInto(el, text, 0);
  }
  function initChars(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-reveal] .sa-display').forEach(splitChars);
  }

  /* The jacket unzips into view */
  function initZip(root) {
    (root || document).querySelectorAll('[data-zip]').forEach(function (z) {
      if (reduce || !('IntersectionObserver' in window)) { z.classList.add('is-open'); return; }
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { z.classList.add('is-open'); io.disconnect(); }
      }, { threshold: 0.45 });
      io.observe(z);
    });
  }

  /* Soft light follows the cursor across dark sections */
  function initSpotlight(root) {
    if (reduce || !finePointer) return;
    (root || document).querySelectorAll('[data-spotlight]').forEach(function (s) {
      s.addEventListener('pointermove', function (e) {
        var r = s.getBoundingClientRect();
        s.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        s.style.setProperty('--my', (e.clientY - r.top) + 'px');
        s.classList.add('is-lit');
      });
      s.addEventListener('pointerleave', function () { s.classList.remove('is-lit'); });
    });
  }

  /* Buttons lean toward the cursor */
  function initMagnets(root) {
    if (reduce || !finePointer) return;
    (root || document).querySelectorAll('.sa-button, .sa-header__cta').forEach(function (b) {
      if (b.dataset.mag) return; b.dataset.mag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--tx', ((e.clientX - r.left - r.width / 2) * .22).toFixed(1) + 'px');
        b.style.setProperty('--ty', ((e.clientY - r.top - r.height / 2) * .3).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--tx', '0px'); b.style.setProperty('--ty', '0px'); });
    });
  }

  /* Close-ups drift slightly against the scroll */
  var frames = [];
  function initParallax(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-parallax]').forEach(function (f) { frames.push(f); });
    updateParallax();
  }
  function updateParallax() {
    var vh = window.innerHeight;
    frames.forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      f.style.setProperty('--py', (p * -26).toFixed(1) + 'px');
    });
  }
  var pTick = false;
  window.addEventListener('scroll', function () {
    if (!frames.length || pTick) return; pTick = true;
    requestAnimationFrame(function () { pTick = false; updateParallax(); });
  }, { passive: true });

  /* A burst of balloons when someone joins the list */
  function burst(fromEl) {
    if (reduce || !document.body.animate) return;
    var r = fromEl ? fromEl.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    var colors = ['#F4F1EA', '#A9C1E8', '#C9DCEB', '#3E5566', '#E7E2D6'];
    for (var i = 0; i < 9; i++) {
      var b = document.createElement('span');
      b.className = 'sa-pop';
      b.style.setProperty('--c', colors[i % colors.length]);
      b.style.left = ox + 'px'; b.style.top = oy + 'px';
      document.body.appendChild(b);
      var dx = (Math.random() - .5) * Math.min(innerWidth, 900);
      var up = innerHeight * (.7 + Math.random() * .6);
      var sc = .6 + Math.random() * .8, rot = (Math.random() - .5) * 40;
      var anim = b.animate([
        { transform: 'translate(0,0) scale(.2) rotate(0deg)', opacity: 0 },
        { transform: 'translate(' + dx * .35 + 'px,' + (-up * .25) + 'px) scale(' + sc + ') rotate(' + rot / 2 + 'deg)', opacity: 1, offset: .2 },
        { transform: 'translate(' + dx + 'px,' + (-up) + 'px) scale(' + sc + ') rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 2600 + Math.random() * 1600, delay: Math.random() * 260, easing: 'cubic-bezier(.2,.6,.3,1)', fill: 'forwards' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(b);
    }
    monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
    if (window.saSound) window.saSound('chime');
  }
  window.saBurst = burst;
  /* Heartbeat sound: synthesized, off by default, only starts after a click */
  (function () {
    var AC = window.AudioContext || window.webkitAudioContext;
    var on = false, ctx = null, master = null, lastBeat = 0;
    function store(v) { try { localStorage.setItem('sa-sound', v ? '1' : '0'); } catch (e) {} }
    function stored() { try { return localStorage.getItem('sa-sound') === '1'; } catch (e) { return false; } }
    function ensure() {
      if (!AC) return false;
      if (!ctx) {
        ctx = new AC();
        master = ctx.createGain(); master.gain.value = 0.9;
        var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 900;
        master.connect(lp); lp.connect(ctx.destination);
      }
      if (ctx.state === 'suspended') ctx.resume();
      return true;
    }
    function thump(t, f, vol) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine';
      o.frequency.setValueAtTime(f, t);
      o.frequency.exponentialRampToValueAtTime(f * 0.45, t + 0.16);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
      o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.25);
    }
    function tone(t, f, vol, len) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'triangle'; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + len);
      o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t + len + 0.05);
    }
    window.saSound = function (kind) {
      if (!on || !ctx || document.hidden) return;
      var t = ctx.currentTime + 0.01;
      if (kind === 'beat') {
        var now = performance.now(); if (now - lastBeat < 350) return; lastBeat = now;
        thump(t, 62, 0.55); thump(t + 0.17, 54, 0.38);
      } else if (kind === 'chime') {
        [523.25, 659.25, 783.99, 1046.5].forEach(function (f, i) { tone(t + i * 0.09, f, 0.06, 1.2); });
      } else if (kind === 'turn') {
        tone(t, 196, 0.035, 0.5);
      }
    };
    function sync() {
      document.querySelectorAll('[data-sound-toggle]').forEach(function (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on (music and heartbeat)');
      });
    }
    function initSound(root) {
      if (!AC) return;
      (root || document).querySelectorAll('[data-sound-toggle]').forEach(function (b) {
        if (b.dataset.ready) return; b.dataset.ready = '1';
        b.hidden = false;
        if (stored()) b.classList.add('is-remembered');
        b.addEventListener('click', function () {
          on = !on;
          if (on && !ensure()) { on = false; return; }
          store(on); sync();
          if (on) window.saSound('beat');
        });
      });
      sync();
    }
    window.saInitSound = initSound;
  })();

  /* Several email forms share one Shopify "posted" state: only the one that was sent shows success */
  var FORM_KEY = 'sa-form-sent';
  function initForms() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.id || !f.querySelector('[name="contact[email]"]')) return;
      try { sessionStorage.setItem(FORM_KEY, f.id); } catch (err) {}
    }, true);
    var sent = null;
    try { sent = sessionStorage.getItem(FORM_KEY); sessionStorage.removeItem(FORM_KEY); } catch (err) {}
    var hash = (location.hash || '').replace('#', '');
    if (!sent && hash && document.getElementById(hash)) sent = hash;
    if (!sent) return;
    document.querySelectorAll('form').forEach(function (f) {
      if (f.id === sent) return;
      f.querySelectorAll('[data-sa-success], [data-sa-error], .sa-signup__error-detail').forEach(function (el) { el.remove(); });
      var fields = f.querySelector('[data-sa-fields]'); if (fields) fields.hidden = false;
      var em = f.querySelector('[name="contact[email]"]'); if (em) { em.value = ''; em.removeAttribute('aria-invalid'); }
    });
  }
  function initBurst() {
    var ok = Array.prototype.filter.call(document.querySelectorAll('.sa-signup__success'), function (el) { return el.offsetParent !== null; })[0];
    if (ok) setTimeout(function () { ok.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); burst(ok); }, 500);
  }


  /* ---------- Flashlight over hidden messages ---------- */
  function initFlashlight(root) {
    (root || document).querySelectorAll('[data-flashlight]').forEach(function (panel) {
      if (panel.dataset.ready) return; panel.dataset.ready = '1';
      var tx = 30, ty = 40, cx = 30, cy = 40, lastMove = -1e9, visible = false, t0 = performance.now();
      function setFromEvent(e) {
        var r = panel.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width * 100; ty = (e.clientY - r.top) / r.height * 100;
        lastMove = performance.now(); panel.classList.add('is-touched');
      }
      panel.addEventListener('pointermove', setFromEvent);
      panel.addEventListener('pointerdown', setFromEvent);
      if (reduce) { panel.style.setProperty('--lx', '50%'); panel.style.setProperty('--ly', '50%'); return; }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) loop(); }).observe(panel);
      function loop() {
        if (!visible) return;
        var now = performance.now();
        if (now - lastMove > 2200) {
          // wander slowly between the hidden messages when nobody is steering
          var t = (now - t0) / 1000;
          tx = 50 + Math.sin(t * .42) * 32 + Math.sin(t * .17) * 8;
          ty = 50 + Math.sin(t * .31 + 1.2) * 26;
        }
        cx += (tx - cx) * .08; cy += (ty - cy) * .08;
        panel.style.setProperty('--lx', cx.toFixed(2) + '%');
        panel.style.setProperty('--ly', cy.toFixed(2) + '%');
        requestAnimationFrame(loop);
      }
    });
  }

  /* ---------- Hotspots: tap to show, tap again to hide ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-hot]').forEach(function (h) {
      if (h.dataset.ready) return; h.dataset.ready = '1';
      h.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = !h.classList.contains('is-on');
        document.querySelectorAll('[data-hot].is-on').forEach(function (o) { o.classList.remove('is-on'); });
        h.classList.toggle('is-on', on);
        monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('[data-hot].is-on').forEach(function (o) { o.classList.remove('is-on'); });
    });
  }

  /* ---------- Heart cursor (mouse only) ---------- */
  function initCursor() {
    var c = document.querySelector('.sa-cursor');
    if (!c || reduce || !finePointer) return;
    var mx = -100, my = -100, rx = -100, ry = -100, shown = false;
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; rx = mx; ry = my; c.classList.add('is-on'); requestAnimationFrame(loop); }
      var hot = e.target.closest && e.target.closest('a, button, input, [data-hot], .sa-balloon, [data-flashlight]');
      c.classList.toggle('is-hover', !!hot);
      c.style.setProperty('--hs', hot ? 1 : 0);
    });
    document.addEventListener('pointerleave', function () { c.classList.remove('is-on'); shown = false; });
    function loop() {
      if (!shown) return;
      rx += (mx - rx) * .18; ry += (my - ry) * .18;
      c.style.setProperty('--cx', rx.toFixed(1) + 'px'); c.style.setProperty('--cy', ry.toFixed(1) + 'px');
      c.style.setProperty('--dx', mx + 'px'); c.style.setProperty('--dy', my + 'px');
      requestAnimationFrame(loop);
    }
  }

  /* ---------- Ticker speeds up and reverses with your scrolling ---------- */
  function initMarquee(root) {
    if (reduce) return;
    var tracks = [].slice.call((root || document).querySelectorAll('.sa-marquee__track'));
    if (!tracks.length || !tracks[0].getAnimations) return;
    var lastY = window.scrollY, vel = 0, dir = 1;
    window.addEventListener('scroll', function () {
      var dy = window.scrollY - lastY; lastY = window.scrollY;
      vel = Math.max(-60, Math.min(60, dy));
      if (dy) dir = dy > 0 ? 1 : -1;
    }, { passive: true });
    (function loop() {
      vel *= .9;
      var rate = dir * (1 + Math.abs(vel) * .12);
      tracks.forEach(function (t) { var a = t.getAnimations()[0]; if (a) a.playbackRate = rate; });
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Send to someone ---------- */
  function initShare(root) {
    (root || document).querySelectorAll('[data-share]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      var status = b.parentNode.querySelector('[data-share-status]');
      b.addEventListener('click', function () {
        var url = location.origin + '/';
        var text = b.dataset.shareText || document.title;
        function say(t) { if (status) status.textContent = t; }
        if (navigator.share) {
          navigator.share({ title: document.title, text: text, url: url }).then(function () { say('Sent.'); }, function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(text + ' ' + url).then(function () { say('Link copied. Paste it to them.'); }, function () { say(url); });
        } else { say(url); }
      });
    });
  }

  /* ---------- A note in the tab when someone looks away ---------- */
  function initTabTitle() {
    var original = document.title, away = 'come back… i think the world of you';
    document.addEventListener('visibilitychange', function () {
      document.title = document.hidden ? away : original;
    });
  }


  /* ======================================================================
     Product page
     ====================================================================== */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = '1';
      var variants = [];
      try { variants = JSON.parse(pdp.querySelector('[data-variants]').textContent); } catch (e) {}
      var form = pdp.querySelector('[data-pdp-form]');
      var idInput = pdp.querySelector('[data-variant-id]');
      var addBtn = pdp.querySelector('[data-add]'), addLabel = pdp.querySelector('[data-add-label]');
      var addText = addLabel ? addLabel.textContent.trim() : 'Add to bag';
      if (addText === 'Sold out') addText = (pdp.querySelector('[data-bar-add]') || {}).textContent || 'Add to bag';
      var status = pdp.querySelector('[data-add-status]');
      var waitlist = pdp.querySelector('[data-waitlist]');
      var bar = pdp.querySelector('[data-bar]'), barAdd = pdp.querySelector('[data-bar-add]');

      /* Gallery */
      var slides = pdp.querySelectorAll('[data-slide]'), thumbs = pdp.querySelectorAll('[data-thumb]');
      var stage = pdp.querySelector('[data-zoom]'), cur = 0;
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        stage && stage.classList.remove('is-zoom');
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
      if (stage) {
        if (finePointer) {
          stage.addEventListener('click', function () { stage.classList.toggle('is-zoom'); });
          stage.addEventListener('pointermove', function (e) {
            var r = stage.getBoundingClientRect();
            var img = slides[cur] && slides[cur].querySelector('img');
            if (img) { img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); }
          });
          stage.addEventListener('pointerleave', function () { stage.classList.remove('is-zoom'); });
        }
        // swipe on phones
        var sx = null;
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
        });
      }

      /* Variant picking */
      function selected() {
        var vals = [];
        pdp.querySelectorAll('[data-option-index]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); vals.push(c ? c.value : null);
        });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var k = 0; k < vals.length; k++) if (variants[i].options[k] !== vals[k]) { ok = false; break; }
          if (ok) return variants[i];
        }
        return null;
      }
      function markAvailability() {
        var vals = selected();
        pdp.querySelectorAll('[data-option]').forEach(function (inp) {
          var k = +inp.dataset.option, test = vals.slice(); test[k] = inp.value;
          var v = findVariant(test);
          inp.closest('.sa-pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      }
      function update() {
        var vals = selected();
        pdp.querySelectorAll('[data-option-label]').forEach(function (l) { l.textContent = vals[+l.dataset.optionLabel] || ''; });
        var v = findVariant(vals);
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        var price = pdp.querySelector('[data-price]'), cmp = pdp.querySelector('[data-compare]');
        price.textContent = v.price;
        if (cmp) { cmp.hidden = !v.compare; cmp.textContent = v.compare || ''; }
        addBtn.disabled = !v.available; addLabel.textContent = v.available ? addText : 'Sold out';
        if (barAdd) { barAdd.disabled = !v.available; barAdd.textContent = v.available ? addText : 'Sold out'; }
        var bv = pdp.querySelector('[data-bar-variant]'), bp = pdp.querySelector('[data-bar-price]');
        if (bv) bv.textContent = v.title === 'Default Title' ? '' : v.title;
        if (bp) bp.textContent = v.price;
        if (waitlist) waitlist.hidden = v.available;
        if (v.media) {
          var sl = pdp.querySelector('[data-media-id="' + v.media + '"]');
          if (sl) go(+sl.dataset.slide);
        }
        markAvailability();
        highlightSize(vals);
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      }
      pdp.querySelectorAll('[data-option]').forEach(function (inp) { inp.addEventListener('change', update); });
      markAvailability();

      /* Add to bag without leaving the page (falls back to a normal submit) */
      function say(html) { if (status) status.innerHTML = html; }
      if (form && window.fetch && window.FormData) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn.disabled) return;
          addBtn.classList.add('is-busy'); say('Adding…');
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function () {
              say('Added to your bag. <a href="' + root + 'cart">View bag →</a>');
              if (window.saCart) window.saCart.added();
              if (window.saBurst && !reduce) window.saBurst(addBtn);
            })
            .catch(function (err) {
              say((err && (err.description || err.message)) || 'That didn’t work. Please try again.');
            })
            .then(function () { addBtn.classList.remove('is-busy'); });
        });
      }

      /* Sticky bar on phones: show once the main button scrolls away */
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (barAdd) barAdd.tabIndex = on ? 0 : -1;
        }).observe(addBtn);
        if (barAdd) barAdd.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
          addBtn.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        });
      }

      /* Size chart */
      var dlg = pdp.querySelector('[data-sizes]');
      function highlightSize(vals) {
        if (!dlg) return;
        dlg.querySelectorAll('tbody tr').forEach(function (tr) {
          var s = tr.querySelector('th').textContent.trim();
          tr.classList.toggle('is-picked', vals.indexOf(s) !== -1);
        });
      }
      highlightSize(selected());
      pdp.querySelectorAll('[data-open-sizes]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (dlg && dlg.showModal) dlg.showModal(); else if (dlg) dlg.setAttribute('open', '');
        });
      });
      if (dlg) {
        dlg.querySelectorAll('[data-close-sizes]').forEach(function (b) { b.addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); }); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
      }
    });
  }


  /* Dedication card: live preview, then drawn to a canvas and shared or saved as a PNG */
  function initDedicate(root) {
    (root || document).querySelectorAll('[data-dedicate]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var form = sec.querySelector('[data-dedicate-form]');
      var nameIn = sec.querySelector('[data-dedicate-name]');
      var fromIn = sec.querySelector('[data-dedicate-from]');
      var out = sec.querySelector('[data-dedicate-out]');
      var fromOut = sec.querySelector('[data-dedicate-from-out]');
      var status = sec.querySelector('[data-dedicate-status]');
      var logo = sec.querySelector('[data-dedicate-logo]');
      var lead = (sec.querySelector('.sa-dcard__lead') || {}).textContent || 'i think the world of';
      var domain = (sec.querySelector('.sa-dcard__url') || {}).textContent || '';
      var fallback = out ? out.textContent : 'you';
      if (!form || !nameIn || !out) return;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { sec.classList.toggle('is-in', e[0].isIntersecting); }, { threshold: .25 });
        io.observe(sec);
      } else sec.classList.add('is-in');

      function clean(v) { return (v || '').replace(/\s+/g, ' ').trim().slice(0, 24); }
      var popT;
      function update() {
        var n = clean(nameIn.value) || fallback;
        out.textContent = n;
        out.classList.toggle('is-long', n.length > 11);
        var f = clean(fromIn && fromIn.value);
        if (fromOut) { fromOut.hidden = !f; fromOut.textContent = f ? '\u2014 ' + f : ''; }
        if (!reduce) { clearTimeout(popT); popT = setTimeout(function () { out.classList.remove('is-pop'); void out.offsetWidth; out.classList.add('is-pop'); }, 220); }
        if (status) status.textContent = '';
      }
      nameIn.addEventListener('input', update);
      if (fromIn) fromIn.addEventListener('input', update);

      function loadImg(src) {
        return new Promise(function (res) {
          var im = new Image(); im.crossOrigin = 'anonymous';
          im.onload = function () { res(im); }; im.onerror = function () { res(null); };
          im.src = src;
        });
      }
      function draw(withLogo) {
        var W = 1080, H = 1920;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var c = cv.getContext('2d');
        var cs = getComputedStyle(document.documentElement);
        var ink = cs.getPropertyValue('--sa-ink').trim() || '#0A0A0B';
        var bone = cs.getPropertyValue('--sa-bone').trim() || '#F4F1EA';
        var glow = cs.getPropertyValue('--sa-glow').trim() || '#A9C1E8';
        var rgb = cs.getPropertyValue('--sa-glow-rgb').trim() || '169,193,232';
        c.fillStyle = ink; c.fillRect(0, 0, W, H);
        var g = c.createRadialGradient(W / 2, H * .47, 0, W / 2, H * .47, W * .75);
        g.addColorStop(0, 'rgba(' + rgb + ',.22)'); g.addColorStop(1, 'rgba(' + rgb + ',0)');
        c.fillStyle = g; c.fillRect(0, 0, W, H);
        c.textAlign = 'center'; c.textBaseline = 'alphabetic';
        var y = 520;
        if (withLogo) {
          var lw = 500, lh = lw * withLogo.naturalHeight / withLogo.naturalWidth;
          c.drawImage(withLogo, (W - lw) / 2, 250, lw, lh); y = 250 + lh + 170;
        }
        c.fillStyle = 'rgba(244,241,234,.6)';
        c.font = '400 34px "IBM Plex Mono", monospace';
        if ('letterSpacing' in c) c.letterSpacing = '7px';
        c.fillText(lead.trim().toLowerCase(), W / 2, y);
        if ('letterSpacing' in c) c.letterSpacing = '0px';
        var name = out.textContent;
        var size = 190;
        c.font = 'italic 300 ' + size + 'px "Cormorant Garamond", serif';
        while (c.measureText(name).width > W * .84 && size > 70) { size -= 6; c.font = 'italic 300 ' + size + 'px "Cormorant Garamond", serif'; }
        c.save(); c.shadowColor = 'rgba(' + rgb + ',.55)'; c.shadowBlur = 60; c.fillStyle = bone;
        c.fillText(name, W / 2, y + 90 + size * .8); c.restore();
        var ey = y + 90 + size * .8 + 150;
        c.save(); c.strokeStyle = glow; c.lineWidth = 5; c.lineJoin = c.lineCap = 'round';
        c.shadowColor = 'rgba(' + rgb + ',.9)'; c.shadowBlur = 18;
        var pts = [[0,20],[110,20],[118,20],[124,8],[130,32],[138,2],[146,36],[152,20],[300,20]];
        var sx = W * .78 / 300, ox = W * .11;
        c.beginPath(); pts.forEach(function (p, i) { var px = ox + p[0] * sx, py = ey + (p[1] - 20) * sx; i ? c.lineTo(px, py) : c.moveTo(px, py); });
        c.stroke(); c.restore();
        c.fillStyle = bone; c.font = 'italic 400 64px "Cormorant Garamond", serif';
        c.fillText('proof you were here.', W / 2, ey + 190);
        var f = fromOut && !fromOut.hidden ? fromOut.textContent : '';
        if (f) { c.fillStyle = 'rgba(244,241,234,.6)'; c.font = '400 30px "IBM Plex Mono", monospace'; c.fillText(f, W / 2, ey + 270); }
        c.fillStyle = 'rgba(244,241,234,.4)'; c.font = '400 24px "IBM Plex Mono", monospace';
        if ('letterSpacing' in c) c.letterSpacing = '6px';
        c.fillText(domain.trim().toUpperCase(), W / 2, H - 110);
        return cv;
      }
      function toBlob(cv) {
        return new Promise(function (res) { try { cv.toBlob(function (b) { res(b); }, 'image/png'); } catch (e) { res(null); } });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (status) status.textContent = 'Making your card…';
        var fontsReady = document.fonts && document.fonts.load ? Promise.all([
          document.fonts.load('italic 300 100px "Cormorant Garamond"'),
          document.fonts.load('italic 400 64px "Cormorant Garamond"'),
          document.fonts.load('400 30px "IBM Plex Mono"')
        ]).catch(function () {}) : Promise.resolve();
        fontsReady.then(function () { return logo ? loadImg(logo.currentSrc || logo.src) : null; })
          .then(function (im) {
            return toBlob(draw(im)).then(function (b) { return b || toBlob(draw(null)); });
          })
          .then(function (blob) {
            if (!blob) { if (status) status.textContent = 'Sorry, this browser could not make the image.'; return; }
            var file = (clean(nameIn.value) || 'you').replace(/[^\w-]+/g, '-').toLowerCase();
            var fname = 'sans-armure-' + file + '.png';
            var fileObj = null;
            try { fileObj = new File([blob], fname, { type: 'image/png' }); } catch (err) {}
            if (fileObj && navigator.canShare && navigator.canShare({ files: [fileObj] })) {
              return navigator.share({ files: [fileObj], title: 'Sans Armure', text: lead.trim() + ' ' + out.textContent + '.' })
                .then(function () { if (status) status.textContent = 'Sent.'; if (window.saBurst) window.saBurst(sec.querySelector('[data-dedicate-card]')); })
                .catch(function () { if (status) status.textContent = ''; });
            }
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a'); a.href = url; a.download = fname;
            document.body.appendChild(a); a.click(); a.remove();
            setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
            if (status) status.textContent = 'Saved. Send it to them.';
            if (window.saBurst) window.saBurst(sec.querySelector('[data-dedicate-card]'));
          });
      });
    });
  }

  /* Blueprint: drag between the drawing and the made jacket */
  function initBlueprint(root) {
    (root || document).querySelectorAll('[data-bp]').forEach(function (bp) {
      if (bp.dataset.ready) return; bp.dataset.ready = '1';
      var sec = bp.closest('.sa-bp') || bp;
      var stage = bp.querySelector('[data-bp-stage]');
      var handle = bp.querySelector('[data-bp-handle]');
      var coords = bp.querySelector('[data-bp-coords]');
      var arts = bp.querySelectorAll('[data-bp-face]');
      var keys = bp.querySelectorAll('[data-bp-key]');
      var views = bp.querySelectorAll('[data-bp-view]');
      if (!stage) return;
      var split = 100, dragging = false, touched = false, anim;

      function set(v) {
        split = Math.max(0, Math.min(100, v));
        stage.style.setProperty('--split', split + '%');
        if (handle) {
          handle.setAttribute('aria-valuenow', Math.round(split));
          handle.setAttribute('aria-valuetext', split > 66 ? 'Mostly drawing' : split < 34 ? 'Mostly photo' : 'Half drawing, half photo');
        }
      }
      function tween(to, ms) {
        cancelAnimationFrame(anim);
        if (reduce) { set(to); return; }
        var from = split, t0 = performance.now();
        (function step(now) {
          var p = Math.min(1, (now - t0) / ms), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          set(from + (to - from) * e);
          if (p < 1) anim = requestAnimationFrame(step);
        })(t0);
      }
      function view(v) {
        stage.dataset.current = v;
        arts.forEach(function (a) { a.hidden = a.dataset.bpFace !== v; });
        keys.forEach(function (k) { k.hidden = k.dataset.bpKey !== v; });
        views.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bpView === v ? 'true' : 'false'); });
        if (!reduce && sec.classList.contains('is-drawn')) { sec.classList.remove('is-drawn'); void sec.offsetWidth; sec.classList.add('is-drawn'); }
      }
      views.forEach(function (b) { b.addEventListener('click', function () { view(b.dataset.bpView); }); });
      view('front');
      set(100);

      function fromEvent(e) { var r = stage.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        dragging = true; touched = true; cancelAnimationFrame(anim);
        stage.classList.add('is-dragging');
        set(fromEvent(e));
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      });
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        stage.style.setProperty('--cx', (x * 100).toFixed(2) + '%');
        stage.style.setProperty('--cy', (y * 100).toFixed(2) + '%');
        if (coords) coords.textContent = 'X ' + ('00' + (x * 100).toFixed(1)).slice(-5) + '   Y ' + ('00' + (y * 100).toFixed(1)).slice(-5);
        if (dragging) set(x * 100);
      });
      stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stage.classList.add('is-hover'); });
      stage.addEventListener('pointerleave', function () { stage.classList.remove('is-hover'); });
      function end() { dragging = false; stage.classList.remove('is-dragging'); }
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
      if (handle) handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 20 : 5;
        if (e.key === 'ArrowLeft') { set(split - step); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { set(split + step); e.preventDefault(); }
        else if (e.key === 'Home') { set(0); e.preventDefault(); }
        else if (e.key === 'End') { set(100); e.preventDefault(); }
        touched = true;
      });

      function reveal() {
        sec.classList.add('is-drawn');
        if (!touched) setTimeout(function () { if (!touched) tween(52, 1600); }, reduce ? 0 : 2300);
      }
      if (reduce || !('IntersectionObserver' in window)) { sec.classList.add('is-drawn'); set(52); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { reveal(); io.disconnect(); } }, { threshold: .35 });
      io.observe(stage);
    });
  }

  /* Edition facade: 117 windows, choose your number */
  function initEdition(root) {
    (root || document).querySelectorAll('[data-edition]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var total = parseInt(sec.dataset.total, 10) || 117;
      var facade = sec.querySelector('[data-facade]');
      var wins = Array.prototype.slice.call(sec.querySelectorAll('.sa-win'));
      var digitsEl = sec.querySelector('[data-digits]');
      var meaning = sec.querySelector('[data-edition-meaning]');
      var input = sec.querySelector('[data-edition-input]');
      var tags = sec.querySelector('[data-edition-tags]');
      var submit = sec.querySelector('[data-edition-submit]');
      var cols = parseInt(getComputedStyle(facade).getPropertyValue('--cols'), 10) || 13;
      var floors = Math.ceil(total / cols);
      var current = 0;

      /* digit rollers */
      var rollers = [];
      if (digitsEl) {
        digitsEl.textContent = '';
        for (var d = 0; d < 3; d++) {
          var wrap = document.createElement('span'); wrap.className = 'sa-digit';
          var col = document.createElement('span');
          var html = '<i>0</i>'; for (var k = 0; k <= 9; k++) html += '<i>' + k + '</i>';
          col.innerHTML = html; wrap.appendChild(col); digitsEl.appendChild(wrap); rollers.push(col);
        }
      }
      function roll(n) {
        var str = ('00' + n).slice(-3);
        rollers.forEach(function (col, i) {
          var v = n ? parseInt(str[i], 10) + 1 : 0;
          col.style.transitionDelay = (i * 0.08) + 's';
          col.style.transform = 'translateY(' + (-v) + 'em)';
        });
        if (digitsEl) digitsEl.setAttribute('aria-label', n ? 'Number ' + n : 'No number chosen');
      }
      function describe(n) {
        var floor = floors - Math.floor((n - 1) / cols);
        var win = ((n - 1) % cols) + 1;
        var extra = n === 1 ? ' · The first one' : n === total ? ' · The last one' : n === 17 ? ' · The 17 on the jacket' : '';
        return 'Floor ' + floor + ' · Window ' + win + extra;
      }
      function choose(n, focus) {
        n = Math.max(1, Math.min(total, n | 0));
        current = n;
        wins.forEach(function (w) {
          var on = +w.dataset.n === n;
          w.setAttribute('aria-pressed', on ? 'true' : 'false');
          w.tabIndex = on ? 0 : -1;
        });
        var w = wins[n - 1];
        if (focus && w) w.focus();
        roll(n);
        if (meaning) meaning.textContent = describe(n);
        if (input && +input.value !== n) input.value = n;
        if (tags) tags.value = 'No. ' + ('00' + n).slice(-3);
        if (submit && submit.dataset.label) submit.textContent = submit.dataset.label.replace('[n]', ('00' + n).slice(-3));
        if (submit) submit.disabled = false;
        if (window.saSound) window.saSound('turn');
      }
      var sold = parseInt(sec.dataset.sold, 10) || 0;
      wins.forEach(function (w) {
        w.addEventListener('click', function () {
          if (w.classList.contains('is-taken')) { if (meaning) meaning.textContent = 'No. ' + ('00' + w.dataset.n).slice(-3) + ' is already out in the world.'; return; }
          choose(+w.dataset.n);
        });
      });
      facade.addEventListener('keydown', function (e) {
        var n = current || 1, map = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: cols, ArrowUp: -cols };
        if (map[e.key] === undefined) return;
        e.preventDefault();
        var nx = Math.max(sold + 1, Math.min(total, n + map[e.key]));
        choose(nx, true);
      });
      if (input) input.addEventListener('input', function () {
        var v = parseInt(input.value, 10);
        if (v >= 1 && v <= total) { if (v <= sold) { if (meaning) meaning.textContent = 'No. ' + ('00' + v).slice(-3) + ' is already out in the world.'; } else choose(v); }
      });
      roll(0);

      /* windows light up at dusk */
      if (reduce || !('IntersectionObserver' in window)) {
        wins.forEach(function (w, i) { if ((i * 37) % 5 < 2) w.classList.add('is-lit'); });
        return;
      }
      var lit = false;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || lit) return; lit = true; io.disconnect();
        var order = wins.filter(function (w) { return !w.classList.contains('is-taken'); }).sort(function () { return Math.random() - .5; }).slice(0, Math.round(total * .42));
        order.forEach(function (w, i) {
          setTimeout(function () { w.classList.add('is-lit'); if (Math.random() < .35) w.classList.add('is-dim'); }, 300 + i * 38 + Math.random() * 120);
        });
        setInterval(function () {
          if (document.hidden) return;
          var w = wins[(Math.random() * wins.length) | 0];
          if (w.getAttribute('aria-pressed') === 'true' || w.classList.contains('is-taken')) return;
          w.classList.toggle('is-lit');
        }, 900);
      }, { threshold: .3 });
      io.observe(facade);
    });
  }

  /* Sheet title block, scale ruler and layout grid */
  var sheetDone = false;
  function initSheet() {
    if (sheetDone) return; sheetDone = true;
    var sheet = document.querySelector('[data-sheet]');
    var ruler = document.querySelector('[data-ruler]');
    var mark = document.querySelector('[data-ruler-mark]');
    var gridBtn = document.querySelectorAll('[data-grid-toggle]');
    function setGrid(on) {
      document.documentElement.classList.toggle('sa-grid-on', on);
      gridBtn.forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? 'Hide the grid' : 'Show the grid'; });
    }
    gridBtn.forEach(function (b) { b.addEventListener('click', function () { setGrid(!document.documentElement.classList.contains('sa-grid-on')); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'g' && e.key !== 'G') return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target; if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      setGrid(!document.documentElement.classList.contains('sa-grid-on'));
    });
    if (!sheet) return;
    var secs = Array.prototype.slice.call(document.querySelectorAll('main .shopify-section, main > section')).filter(function (s) { return s.offsetHeight > 0; });
    var noEl = sheet.querySelector('[data-sheet-no]'), nameEl = sheet.querySelector('[data-sheet-name]'), countEl = sheet.querySelector('[data-sheet-count]');
    var names = secs.map(function (s, i) {
      var inner = s.matches('[data-sheet-title]') ? s : s.querySelector('[data-sheet-title]');
      var t = inner && inner.getAttribute('data-sheet-title');
      if (!t) { var eb = s.querySelector('.sa-eyebrow'); t = eb ? eb.textContent : ''; }
      if (!t) { var h = s.querySelector('h1, h2'); t = h ? h.textContent : ''; }
      t = (t || 'Sheet').replace(/\s+/g, ' ').trim();
      if (i === 0) t = 'Cover';
      return t.length > 22 ? t.slice(0, 21) + '…' : t;
    });
    secs.forEach(function (s, i) {
      var inner = s.querySelector('[data-bp-sheet]');
      if (inner) inner.textContent = 'A-' + (101 + i) + ' of ' + secs.length;
    });
    var cur = -1;
    function show(i) {
      if (i === cur || i < 0) return; cur = i;
      noEl.textContent = 'A-' + (101 + i);
      nameEl.textContent = names[i];
      if (countEl) countEl.textContent = 'Sheet ' + (i + 1) + ' of ' + secs.length + ' · Drop 001';
      if (!reduce) { sheet.classList.remove('is-flip'); void sheet.offsetWidth; sheet.classList.add('is-flip'); }
    }
    var tick = false;
    function update() {
      tick = false;
      var mid = innerHeight * .45, idx = 0;
      for (var i = 0; i < secs.length; i++) { if (secs[i].getBoundingClientRect().top <= mid) idx = i; }
      show(idx);
      var max = document.documentElement.scrollHeight - innerHeight;
      var p = max > 0 ? scrollY / max : 0;
      if (mark) mark.style.setProperty('--p', p.toFixed(4));
      var on = scrollY > innerHeight * .5;
      sheet.classList.toggle('is-on', on);
      if (ruler) ruler.classList.toggle('is-on', on);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* The house: chapters as floors, follow one */
  function initHouse(root) {
    (root || document).querySelectorAll('[data-house]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var floors = sec.querySelectorAll('.sa-floor');
      var panel = sec.querySelector('[data-house-panel]');
      if (!panel || !floors.length) return;
      var lvl = panel.querySelector('[data-house-level]'), nm = panel.querySelector('[data-house-name]');
      var meta = panel.querySelector('[data-house-meta]'), desc = panel.querySelector('[data-house-desc]');
      var tags = panel.querySelector('[data-house-tags]'), label = panel.querySelector('[data-house-follow-label]');
      var baseLabel = label ? label.textContent : '';
      function pick(f, animate) {
        floors.forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        var n = ('0' + f.dataset.floor).slice(-2);
        if (lvl) lvl.textContent = 'Floor ' + n;
        if (nm) nm.textContent = f.dataset.name;
        if (meta) meta.textContent = [f.dataset.category, f.dataset.statusLabel, f.dataset.year].filter(Boolean).join(' · ');
        var tpl = f.parentNode.querySelector('template[data-floor-desc]');
        if (desc && tpl) desc.innerHTML = tpl.innerHTML;
        if (tags) tags.value = 'prelaunch, ' + f.dataset.tag;
        if (label) label.textContent = f.dataset.status === 'open' ? baseLabel : (f.dataset.status === 'building' ? 'Tell me when this floor opens' : 'Tell me when this floor is built');
        if (animate && !reduce) { panel.classList.remove('is-swap'); void panel.offsetWidth; panel.classList.add('is-swap'); }
      }
      floors.forEach(function (f) { f.addEventListener('click', function () { pick(f, true); if (window.saSound) window.saSound('turn'); }); });
      var first = sec.querySelector('.sa-floor[data-floor="1"]') || floors[floors.length - 1];
      pick(first, false);
    });
  }

  /* Proof you were here: visits kept on this device, letters open as people return */
  var proofDone = false;
  function initProof() {
    if (proofDone) return; proofDone = true;
    var box = document.querySelector('[data-proof]');
    if (!box) return;
    var KEY = 'sa-proof-v1';
    var gap = (parseFloat(box.dataset.gapHours) || 6) * 3600000;
    var store = null;
    try { var raw = localStorage.getItem(KEY); store = raw ? JSON.parse(raw) : null; } catch (e) { store = null; }
    var memoryOnly = false;
    try { localStorage.setItem('sa-proof-test', '1'); localStorage.removeItem('sa-proof-test'); } catch (e) { memoryOnly = true; }
    if (!store || !Array.isArray(store.v)) store = { v: [], seen: 0 };
    var now = Date.now(), last = store.v[store.v.length - 1] || 0;
    var isNewVisit = !last || now - last > gap;
    if (isNewVisit) { store.v.push(now); if (store.v.length > 400) store.v = store.v.slice(-400); }
    var count = store.v.length;
    function save() { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }
    save();

    var tab = box.querySelector('[data-proof-open]'), dlg = box.querySelector('[data-proof-dialog]');
    var toast = box.querySelector('[data-proof-toast]');
    var letters = Array.prototype.slice.call(box.querySelectorAll('[data-letter]'));
    var fmt = function (t) { try { return new Date(t).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; } };

    var openCount = 0, freshCount = 0;
    letters.forEach(function (l) {
      var need = parseInt(l.dataset.visits, 10) || 1;
      if (count >= need) {
        openCount++;
        l.classList.add('is-open');
        l.querySelector('.sa-letter__open').hidden = false;
        if (need > (store.seen || 0)) { l.classList.add('is-fresh'); freshCount++; }
      } else {
        var w = l.querySelector('.sa-letter__when');
        if (w) w.textContent = 'Opens on visit ' + need + ' · ' + (need - count) + ' to go';
      }
    });

    if (tab) {
      tab.hidden = false;
      tab.querySelector('[data-proof-count]').textContent = count;
      tab.setAttribute('aria-label', 'Proof you were here: ' + count + (count === 1 ? ' visit' : ' visits') + (freshCount ? ', new letter' : ''));
      if (freshCount && count > 1) tab.classList.add('has-new');
    }
    if (freshCount && count > 1 && toast) {
      setTimeout(function () {
        toast.textContent = freshCount > 1 ? freshCount + ' letters opened for you' : 'A letter opened for you';
        toast.classList.add('is-on');
        setTimeout(function () { toast.classList.remove('is-on'); }, 5200);
      }, 3200);
    }

    function draw() {
      var first = box.querySelector('[data-proof-first]'), vis = box.querySelector('[data-proof-visits]'), lst = box.querySelector('[data-proof-last]');
      if (first) first.textContent = fmt(store.v[0]);
      if (vis) vis.textContent = count + (memoryOnly ? ' (this visit only)' : '');
      if (lst) lst.textContent = count > 1 ? fmt(store.v[count - 2]) : 'Now';
      var svg = box.querySelector('[data-proof-ecg]'); if (!svg) return;
      var pts = store.v.slice(-24), n = pts.length, d = 'M0 35';
      pts.forEach(function (t, i) {
        var x = n === 1 ? 300 : 30 + i * (540 / (n - 1));
        var h = 16 + (i === n - 1 ? 14 : (i % 3) * 3);
        d += ' L' + (x - 12) + ' 35 L' + (x - 6) + ' ' + (35 - h * .35) + ' L' + x + ' ' + (35 + h * .5) + ' L' + (x + 5) + ' ' + (35 - h) + ' L' + (x + 10) + ' ' + (35 + h * .35) + ' L' + (x + 15) + ' 35';
      });
      d += ' L600 35';
      var path = svg.querySelector('path'); path.setAttribute('d', d);
      if (!reduce && path.getTotalLength) {
        var len = path.getTotalLength();
        path.style.strokeDasharray = len; path.style.strokeDashoffset = len;
        path.getBoundingClientRect();
        path.style.transition = 'stroke-dashoffset 1.8s cubic-bezier(.3,.6,.2,1)';
        path.style.strokeDashoffset = 0;
      }
    }
    function open() {
      draw();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      tab.classList.remove('has-new');
      var maxOpen = 0; letters.forEach(function (l) { var need = +l.dataset.visits; if (count >= need) maxOpen = Math.max(maxOpen, need); });
      store.seen = Math.max(store.seen || 0, maxOpen); save();
      if (window.saSound) window.saSound('beat');
    }
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); letters.forEach(function (l) { l.classList.remove('is-fresh'); }); }
    if (tab && dlg) {
      tab.addEventListener('click', open);
      box.querySelector('[data-proof-close]').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { letters.forEach(function (l) { l.classList.remove('is-fresh'); }); });
    }
    var clear = box.querySelector('[data-proof-clear]');
    if (clear) clear.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      clear.textContent = 'Forgotten';
      setTimeout(function () { location.reload(); }, 700);
    });
  }

  /* Tees: the light switch between white and black, paint on click, add to bag */
  function initTees(root) {
    (root || document).querySelectorAll('[data-tees]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var sw = sec.querySelector('[data-tees-switch]'), wash = sec.querySelector('[data-tees-wash]');
      var nameEl = sec.querySelector('[data-tees-name]');
      var tees = sec.querySelectorAll('[data-tee]');
      var busy = false;
      function apply(mode) {
        sec.dataset.mode = mode;
        tees.forEach(function (t) {
          var on = t.dataset.tee === mode; t.hidden = !on;
          if (on && !reduce) { t.classList.remove('is-entering'); void t.offsetWidth; t.classList.add('is-entering'); }
        });
        if (nameEl) nameEl.textContent = mode === 'black' ? 'Black' : 'White';
        if (sw) { sw.setAttribute('aria-pressed', mode === 'black' ? 'true' : 'false'); sw.setAttribute('aria-label', mode === 'black' ? 'Show the white tee' : 'Show the black tee'); }
      }
      if (sw) sw.addEventListener('click', function () {
        if (busy) return;
        var next = sec.dataset.mode === 'black' ? 'white' : 'black';
        if (window.saSound) window.saSound('turn');
        if (reduce || !wash) { apply(next); return; }
        busy = true;
        var r = sec.getBoundingClientRect(), b = sw.getBoundingClientRect();
        wash.style.setProperty('--wx', (b.left + b.width / 2 - r.left) + 'px');
        wash.style.setProperty('--wy', (b.top + b.height / 2 - r.top) + 'px');
        wash.style.background = next === 'black' ? '#0A0A0B' : getComputedStyle(document.documentElement).getPropertyValue('--sa-bone');
        wash.classList.remove('is-going'); void wash.offsetWidth; wash.classList.add('is-going');
        setTimeout(function () { apply(next); }, 420);
        setTimeout(function () { wash.classList.remove('is-going'); wash.style.background = ''; busy = false; }, 1150);
      });

      sec.querySelectorAll('[data-tee-flip]').forEach(function (print) {
        var btn = print.querySelector('[data-tee-turn]');
        function flip() {
          var back = !print.classList.contains('is-back');
          print.classList.toggle('is-back', back);
          if (btn) { btn.textContent = back ? 'See the front' : 'See the back'; btn.setAttribute('aria-pressed', back ? 'true' : 'false'); }
        }
        if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); flip(); });
        print.addEventListener('click', flip);
      });

      /* hand-applied splatter: click anywhere in the section */
      if (!reduce) sec.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button, a, input, label, [data-tee-flip], form')) return;
        var r = sec.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        var n = 6 + (Math.random() * 7 | 0);
        for (var i = 0; i < n; i++) {
          var d = document.createElement('span'); d.className = 'sa-splat';
          var s = i === 0 ? 10 + Math.random() * 12 : 2 + Math.random() * 7;
          var a = Math.random() * Math.PI * 2, dist = i === 0 ? 0 : 8 + Math.random() * 46;
          d.style.width = d.style.height = s + 'px';
          d.style.left = (x + Math.cos(a) * dist) + 'px'; d.style.top = (y + Math.sin(a) * dist) + 'px';
          d.style.animationDelay = (i * 0.012) + 's';
          sec.appendChild(d);
          setTimeout(function (el) { el.remove(); }.bind(null, d), 2800);
        }
      });

      sec.querySelectorAll('[data-tee-form]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var st = form.querySelector('[data-tee-status]'), btn = form.querySelector('[data-tee-add]');
          var fd = new FormData(form);
          if (!fd.get('id')) { if (st) st.textContent = 'Choose a size first.'; return; }
          if (btn) btn.disabled = true;
          if (st) st.textContent = 'Adding…';
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
              if (st) st.innerHTML = 'Added to your bag. <a href="' + root + 'cart">View bag →</a>';
              if (window.saCart) window.saCart.added();
              if (window.saBurst) window.saBurst(btn);
            })
            .catch(function (err) { if (st) st.textContent = err.message || 'Something went wrong. Try again.'; })
            .then(function () { if (btn) btn.disabled = false; });
        });
      });
    });
  }

  /* Bag: header count and a slide-out bag that talks to Shopify's cart */
  var bagDone = false;
  function initBag() {
    if (bagDone) return; bagDone = true;
    var bag = document.querySelector('[data-bag]');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var openers = document.querySelectorAll('[data-bag-open]');
    var lastFocus = null, cart = null;
    function money(c, cur) { try { return (c / 100).toLocaleString(undefined, { style: 'currency', currency: cur || 'USD' }); } catch (e) { return '$' + (c / 100).toFixed(2); } }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function setCount(n, bump) {
      document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = n; });
      openers.forEach(function (o) {
        o.classList.toggle('has-items', n > 0);
        o.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items'));
        if (bump && !reduce) { o.classList.remove('is-bump'); void o.offsetWidth; o.classList.add('is-bump'); setTimeout(function () { o.classList.remove('is-bump'); }, 450); }
      });
    }
    function render() {
      if (!bag || !cart) return;
      var list = bag.querySelector('[data-bag-items]'), empty = bag.querySelector('[data-bag-empty]'), foot = bag.querySelector('[data-bag-foot]');
      var has = cart.item_count > 0;
      empty.hidden = has; foot.hidden = !has; list.hidden = !has;
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? (it.image.indexOf('data:') === 0 ? it.image : it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        return '<div class="sa-bag__item" data-key="' + esc(it.key) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><p class="sa-bag__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
          (variant ? '<p class="sa-bag__variant">' + esc(variant) + '</p>' : '') +
          (it.properties && it.properties['Pre-order'] ? '<p class="sa-bag__pre sa-mono">' + esc(it.properties['Pre-order']) + '</p>' : '') +
          '<div class="sa-bag__qty"><button type="button" data-qty="-1" aria-label="One less">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="One more">+</button></div></div>' +
          '<div><p class="sa-bag__line">' + money(it.final_line_price, cart.currency) + '</p><button type="button" class="sa-bag__remove" data-remove>Remove</button></div></div>';
      }).join('');
      bag.querySelector('[data-bag-subtotal]').textContent = money(cart.total_price, cart.currency);
      setCount(cart.item_count);
    }
    function refresh() {
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; render(); return c; })
        .catch(function () {});
    }
    function change(key, qty, row) {
      if (row) row.classList.add('is-busy');
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items) { cart = c; render(); } else { refresh(); } })
        .catch(function () { refresh(); });
    }
    function open() {
      if (!bag) { location.href = root + 'cart'; return; }
      lastFocus = document.activeElement;
      bag.hidden = false;
      requestAnimationFrame(function () { bag.classList.add('is-open'); });
      var panel = bag.querySelector('.sa-bag__panel'); if (panel) panel.focus();
      document.documentElement.style.overflow = 'hidden';
      refresh();
    }
    function close() {
      if (!bag) return;
      bag.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { bag.hidden = true; }, reduce ? 0 : 450);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (o) { o.addEventListener('click', function (e) { if (!bag) return; e.preventDefault(); open(); }); });
    if (bag) {
      bag.querySelectorAll('[data-bag-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bag.hidden) close(); });
      bag.querySelector('[data-bag-items]').addEventListener('click', function (e) {
        var row = e.target.closest('.sa-bag__item'); if (!row || !cart) return;
        var key = row.dataset.key, it = cart.items.filter(function (x) { return x.key === key; })[0]; if (!it) return;
        if (e.target.closest('[data-remove]')) change(key, 0, row);
        var q = e.target.closest('[data-qty]'); if (q) change(key, Math.max(0, it.quantity + parseInt(q.dataset.qty, 10)), row);
      });
    }
    window.saCart = { open: open, refresh: refresh, added: function () { refresh().then(function (c) { if (c) setCount(c.item_count, true); open(); }); } };
    var n = parseInt((openers[0] && openers[0].querySelector('[data-bag-count]') || {}).textContent, 10);
    if (!isNaN(n)) setCount(n);
  }

  /* Quick buy on the home page, and a buy bar that follows the page */
  function ajaxAdd(fd) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function initQuickbuy(root) {
    (root || document).querySelectorAll('[data-quickbuy]').forEach(function (form) {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      var st = form.querySelector('[data-quickbuy-status]'), btn = form.querySelector('[data-quickbuy-add]');
      form.addEventListener('change', function (e) {
        if (e.target.name !== 'id') return;
        var sel = document.querySelector('[data-buybar-size]'); if (sel) sel.value = e.target.value;
        var bb = document.querySelector('[data-buybar-add]'); if (bb) bb.dataset.variant = e.target.value;
      });
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var fd = new FormData(form);
        if (!fd.get('id')) { if (st) st.textContent = 'Choose a size first.'; return; }
        btn.disabled = true; if (st) st.textContent = 'Adding…';
        ajaxAdd(fd).then(function () {
          if (st) st.textContent = 'Added to your bag.';
          if (window.saBurst) window.saBurst(btn);
          if (window.saCart) window.saCart.added();
        }).catch(function (err) { if (st) st.textContent = err.message; })
          .then(function () { btn.disabled = false; });
      });
    });
  }
  var buybarDone = false;
  function initBuybar() {
    if (buybarDone) return;
    var bar = document.querySelector('[data-buybar]'); if (!bar) return;
    buybarDone = true;
    var buy = document.querySelector('[data-drop-buy]') || bar.closest('section');
    var stop = document.getElementById('join') || document.querySelector('.sa-footer');
    var on = false, tick = false;
    function set(v) {
      if (v === on) return; on = v;
      bar.classList.toggle('is-on', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      bar.querySelectorAll('a, button, select').forEach(function (el) { el.tabIndex = v ? 0 : -1; });
      document.body.classList.toggle('has-buybar', v);
    }
    function update() {
      tick = false;
      var past = buy.getBoundingClientRect().bottom < 0;
      var atEnd = stop && stop.getBoundingClientRect().top < innerHeight * .85;
      var bagOpen = document.querySelector('[data-bag].is-open');
      set(past && !atEnd && !bagOpen);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var sel = bar.querySelector('[data-buybar-size]'), add = bar.querySelector('[data-buybar-add]');
    if (sel && add) sel.addEventListener('change', function () {
      add.dataset.variant = sel.value;
      var r = document.querySelector('[data-quickbuy] input[name="id"][value="' + sel.value + '"]'); if (r) r.checked = true;
    });
    if (add) add.addEventListener('click', function () {
      var fd = new FormData(); fd.append('id', add.dataset.variant); fd.append('quantity', '1');
      if (add.dataset.preorder) fd.append('properties[Pre-order]', add.dataset.preorder);
      bar.classList.add('is-busy');
      ajaxAdd(fd).then(function () { if (window.saBurst) window.saBurst(add); if (window.saCart) window.saCart.added(); })
        .catch(function (err) { var p = bar.querySelector('[data-buybar-price]'); if (p) p.textContent = err.message; })
        .then(function () { bar.classList.remove('is-busy'); });
    });
  }

  /* Size helper inside the size chart */
  function initFinder(root) {
    (root || document).querySelectorAll('[data-finder]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var rows = [], advice = '';
      try { rows = JSON.parse(box.querySelector('[data-finder-rows]').textContent); } catch (e) {}
      try { advice = JSON.parse(box.querySelector('[data-finder-advice]').textContent) || ''; } catch (e) {}
      var usual = box.querySelector('[data-finder-usual]'), chest = box.querySelector('[data-finder-chest]'), out = box.querySelector('[data-finder-result]');
      function range(t) { var m = String(t || '').match(/[\d.]+/g); if (!m) return null; var a = parseFloat(m[0]), b = parseFloat(m[m.length - 1]); return [a, b]; }
      function run() {
        var c = parseFloat(chest.value), pick = null, why = '';
        var hasBody = rows.some(function (r) { return r.body; });
        if (!isNaN(c) && c > 0) {
          if (hasBody) {
            var best = null, bestD = 1e9;
            rows.forEach(function (r) { var g = range(r.body); if (!g) return; var d = c < g[0] ? g[0] - c : c > g[1] ? c - g[1] : 0; if (d < bestD) { bestD = d; best = r; } });
            if (best) { pick = best.size; why = bestD === 0 ? 'Your chest sits right in its range.' : 'It\'s the closest match to your chest.'; }
          } else {
            var ease = 6, best2 = null;
            rows.forEach(function (r) { var g = range(r.chest); if (g && !best2 && g[0] >= c + ease) best2 = r; });
            if (!best2 && rows.length) best2 = rows[rows.length - 1];
            if (best2) { pick = best2.size; why = 'That leaves the room this oversized cut is meant to have.'; }
          }
        } else if (usual.value) {
          pick = usual.value; why = 'It runs true to your usual size.';
        }
        if (!pick) { out.textContent = ''; return; }
        out.innerHTML = 'We\'d suggest <strong>' + pick.replace(/</g, '') + '</strong>. ' + why + (advice ? ' ' + advice.replace(/</g, '') : '');
      }
      usual.addEventListener('change', run); chest.addEventListener('input', run);
    });
    if (location.hash === '#sizes') {
      var dlg = document.querySelector('[data-sizes]');
      if (dlg && dlg.showModal) setTimeout(function () { try { dlg.showModal(); } catch (e) {} }, 400);
    }
  }

  /* Soft light that follows the cursor across dark sections */
  var lightDone = false;
  function initLight() {
    if (lightDone || reduce || !finePointer) return; lightDone = true;
    document.documentElement.classList.add('has-light');
    var cur = null, tick = false, ev = null;
    document.addEventListener('pointermove', function (e) {
      ev = e; if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var sec = ev.target && ev.target.closest ? ev.target.closest('.sa-section.scheme-dark') : null;
        if (cur && cur !== sec) { cur.style.setProperty('--ly', '-20%'); }
        cur = sec; if (!sec) return;
        var r = sec.getBoundingClientRect();
        sec.style.setProperty('--lx', (ev.clientX - r.left) + 'px');
        sec.style.setProperty('--ly', (ev.clientY - r.top) + 'px');
      });
    }, { passive: true });
  }

  function initSignature(root) {
    initChars(root); initMonitor(root); initSky(root); initZip(root);
    initSpotlight(root); initMagnets(root); initParallax(root);
    initFlashlight(root); initHotspots(root); initMarquee(root); initShare(root);
    initProduct(root); initDedicate(root); initBlueprint(root); initEdition(root); initHouse(root); initTees(root); initQuickbuy(root); initFinder(root);
    if (window.saInitSound) window.saInitSound(root);
  }

  function init(root) {
    initSignature(root);
    initReveals(root);
    initWords(root);
    initStage(root);
    initCountdown(root);
  }

  document.documentElement.classList.add('js');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeader(); initProgress(); initCursor(); initTabTitle(); initForms(); init(); initBag(); initBuybar(); initLight(); initSheet(); initProof(); initBurst(); markSeen(); });
  } else { initHeader(); initProgress(); initCursor(); initTabTitle(); initForms(); init(); initBag(); initBuybar(); initLight(); initSheet(); initProof(); initBurst(); markSeen(); }

  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* Sans Armure — Drop 001 additions: pulse sync, pre-order heartbeat, founders in sync */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function monitors() { return Array.prototype.slice.call(document.querySelectorAll('[data-monitor]')); }
  function setBpm(bpm) {
    var steps = Math.max(24, Math.min(160, Math.round(7200 / bpm)));
    monitors().forEach(function (m) { m.saInterval = steps; });
  }
  function beatAll() { monitors().forEach(function (m) { if (m.saTrigger) m.saTrigger(); }); }

  var haptics = false, lastBuzz = 0;
  function wrapSound() {
    var orig = window.saSound;
    window.saSound = function (kind) {
      if (kind === 'beat' && haptics && navigator.vibrate && !document.hidden) {
        var now = Date.now();
        if (now - lastBuzz > 320) { lastBuzz = now; try { navigator.vibrate(22); } catch (e) {} }
      }
      if (orig) return orig.apply(this, arguments);
    };
  }

  /* Tap along with your heartbeat: the page learns your pulse and beats with it */
  function initPulse() {
    document.querySelectorAll('[data-pulse]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var btn = box.querySelector('[data-pulse-tap]'), status = box.querySelector('[data-pulse-status]'), label = box.querySelector('[data-pulse-label]');
      var taps = [], saved = null;
      try { saved = parseInt(localStorage.getItem('sa-pulse'), 10); } catch (e) {}
      if (saved >= 40 && saved <= 180) {
        setBpm(saved);
        btn.classList.add('is-synced');
        if (label) label.textContent = 'Your pulse · ' + saved + ' bpm';
        if (status) status.textContent = 'The page is beating with you. Tap again to re-sync.';
      }
      btn.addEventListener('click', function () {
        var now = performance.now();
        if (taps.length && now - taps[taps.length - 1] > 2200) taps = [];
        taps.push(now);
        beatAll();
        if (!reduce) { btn.classList.remove('is-tap'); void btn.offsetWidth; btn.classList.add('is-tap'); setTimeout(function () { btn.classList.remove('is-tap'); }, 140); }
        if (navigator.vibrate) { haptics = true; try { navigator.vibrate(15); } catch (e) {} }
        if (taps.length < 4) {
          if (status) status.textContent = taps.length === 1 ? 'Keep tapping, one tap per beat…' : (4 - taps.length) + ' more…';
          return;
        }
        var gaps = [];
        for (var i = 1; i < taps.length; i++) gaps.push(taps[i] - taps[i - 1]);
        gaps = gaps.slice(-6).sort(function (a, b) { return a - b; });
        var mid = gaps[Math.floor(gaps.length / 2)];
        var bpm = Math.round(Math.max(40, Math.min(180, 60000 / mid)));
        setBpm(bpm);
        try { localStorage.setItem('sa-pulse', String(bpm)); } catch (e) {}
        btn.classList.add('is-synced');
        if (label) label.textContent = 'Your pulse · ' + bpm + ' bpm';
        if (status) status.textContent = 'Synced. The whole page now beats at ' + bpm + ' bpm, with you.';
      });
    });
  }

  /* Pre-order: the heart races, then settles */
  function initRace() {
    if (!window.saCart || window.saCart.raced) return;
    var added = window.saCart.added;
    window.saCart.added = function () {
      var ms = monitors(), before = ms.map(function (m) { return m.saInterval; });
      ms.forEach(function (m) { m.saInterval = 26; });
      if (!reduce) { var n = 0, t = setInterval(function () { beatAll(); if (++n > 5) clearInterval(t); }, 230); }
      setTimeout(function () { ms.forEach(function (m, i) { m.saInterval = before[i]; }); }, 3200);
      return added.apply(this, arguments);
    };
    window.saCart.raced = true;
  }

  /* Founders: hover one card and both hearts beat together */
  function initFounders() {
    document.querySelectorAll('[data-founders]').forEach(function (sec) {
      if (sec.dataset.syncReady) return; sec.dataset.syncReady = '1';
      var cards = sec.querySelectorAll('[data-founder]'), line = sec.querySelector('[data-founders-sync]'), timer = null;
      function sync(on) {
        sec.classList.toggle('is-synced', on);
        var ms = sec.querySelectorAll('[data-monitor]');
        if (on) {
          ms.forEach(function (m) { m.saInterval = 58; });
          clearInterval(timer);
          timer = setInterval(function () { ms.forEach(function (m) { if (m.saTrigger) m.saTrigger(); }); }, 900);
          ms.forEach(function (m) { if (m.saTrigger) m.saTrigger(); });
          if (line) line.textContent = 'In sync.';
        } else {
          clearInterval(timer);
          ms.forEach(function (m, i) { m.saInterval = i ? 71 : 64; });
          if (line) line.textContent = line.dataset.base || line.textContent;
        }
      }
      if (line) line.dataset.base = line.textContent;
      sec.querySelectorAll('[data-monitor]').forEach(function (m, i) { m.saInterval = i ? 71 : 64; });
      cards.forEach(function (c) {
        c.addEventListener('pointerenter', function () { sync(true); });
        c.addEventListener('pointerleave', function () { sync(false); });
        c.addEventListener('focusin', function () { sync(true); });
        c.addEventListener('focusout', function () { sync(false); });
      });
    });
  }

  /* Links to #sizes open the size chart */
  function initSizesHash() {
    if (location.hash !== '#sizes') return;
    var b = document.querySelector('[data-open-sizes]'); if (b) setTimeout(function () { b.click(); }, 400);
  }

  function boot() { wrapSound(); initPulse(); initSizesHash(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
  document.addEventListener('shopify:section:load', function () { initPulse(); initFounders(); });
})();
/* Sans Armure — Drop 001, Rev 04: launch phases, soundscape, fit simulator, sun & moon sleeves */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = $('.sa-toast');
    if (!t) { t = document.createElement('div'); t.className = 'sa-toast sa-mono'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }

  /* ---------- Launch phases: waitlist → early access → open ---------- */
  var BTN = '[data-add],[data-bar-add],[data-buybar-add],[data-quickbuy-add],[data-tee-add]';
  function sha256(text) {
    if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    });
  }
  function initGate() {
    var cfg = $('[data-gate-config]'), dlg = $('[data-gate]');
    if (!cfg || !dlg) return;
    var phase = cfg.getAttribute('data-phase'), hash = cfg.getAttribute('data-code') || '';
    var label = phase === 'waitlist' ? 'Join the list' : 'Unlock early access';
    function locked() { return phase === 'waitlist' || (phase === 'early_access' && read('sa-access') !== hash); }
    function paint() {
      var on = locked();
      html.classList.toggle('sa-locked', on);
      html.classList.toggle('sa-unlocked', !on);
      html.setAttribute('data-phase', phase);
      $$(BTN).forEach(function (b) {
        if (on) {
          if (!b.hasAttribute('data-gate-btn')) {
            b.setAttribute('data-gate-btn', '');
            b.style.setProperty('--gate-c', getComputedStyle(b).color);
            if (b.disabled) { b.dataset.gateWasDisabled = '1'; b.disabled = false; }
          }
          b.setAttribute('data-gate-label', label);
        } else if (b.hasAttribute('data-gate-btn')) {
          b.removeAttribute('data-gate-btn');
          if (b.dataset.gateWasDisabled) { b.disabled = true; delete b.dataset.gateWasDisabled; }
        }
      });
    }
    function open(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
      if (dlg.showModal && !dlg.open) { try { dlg.showModal(); } catch (err) { dlg.setAttribute('open', ''); } }
      if (window.saSound) window.saSound('beat');
      var f = $('#SaGateCode', dlg) || $('input[type=email]', dlg); if (f) setTimeout(function () { f.focus(); }, 60);
    }
    function unlock(fromLink) {
      store('sa-access', hash); paint();
      if (dlg.open) dlg.close();
      toast(fromLink ? 'Welcome to the inner circle. Early access is unlocked.' : 'You\'re in. Early access is unlocked.');
      if (window.saSound) window.saSound('chime');
      if (window.saBurst) { var b = $(BTN); if (b) window.saBurst(b); }
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-gate-open]');
      if (t) return open(e);
      if (!locked()) return;
      var b = e.target.closest && e.target.closest(BTN);
      if (b) open(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (!locked()) return;
      var f = e.target; if (f && f.action && /\/cart\/add/.test(f.action)) open(e);
    }, true);
    $$('[data-gate-close]', dlg).forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var codeForm = $('[data-gate-code]', dlg);
    if (codeForm) codeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (codeForm.code.value || '').trim().toUpperCase(), msg = $('[data-gate-msg]', codeForm);
      sha256(v).then(function (h) {
        if (h && h === hash) unlock(false);
        else { msg.textContent = 'That code isn\'t right. Check it and try again.'; codeForm.classList.remove('is-shake'); void codeForm.offsetWidth; codeForm.classList.add('is-shake'); }
      });
    });
    var list = $('.sa-gate__list', dlg);
    if (list) list.addEventListener('submit', function () {
      var tags = $('[data-gate-tags]', list), size = $('[data-gate-size]:checked', list);
      if (tags && size && tags.value.indexOf('size-') < 0) tags.value += ',size-' + size.value;
    });
    if ($('.sa-gate__ok, .sa-gate__list [role=alert]', dlg)) open();
    // Private link: ?access=CODE
    try {
      var u = new URL(location.href), q = u.searchParams.get('access');
      if (q && phase === 'early_access') {
        sha256(q.trim().toUpperCase()).then(function (h) { if (h === hash) unlock(true); });
        u.searchParams.delete('access'); history.replaceState(null, '', u.toString());
      }
    } catch (e) {}
    paint();
    new MutationObserver(function () { if (locked()) paint(); }).observe(document.body, { childList: true, subtree: true });
    window.saGate = { open: open, locked: locked, reset: function () { store('sa-access', null); paint(); } };
  }

  /* ---------- Soundscape: an original ambient score, or your own licensed track ---------- */
  function initMusic() {
    var cfg = $('[data-music-config]'), toggles = $$('[data-sound-toggle]');
    if (!toggles.length) return;
    var src = cfg ? cfg.getAttribute('data-src') : '', vol = cfg ? (parseInt(cfg.getAttribute('data-vol'), 10) || 55) / 100 : .55;
    var AC = window.AudioContext || window.webkitAudioContext, ctx, out, verb, audio, playing = false, timer = null, step = 0;
    function reverb() {
      var len = ctx.sampleRate * 3.2, buf = ctx.createBuffer(2, len, ctx.sampleRate);
      for (var c = 0; c < 2; c++) { var d = buf.getChannelData(c); for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.6); }
      var cv = ctx.createConvolver(); cv.buffer = buf; return cv;
    }
    function setup() {
      if (ctx || !AC) return !!ctx;
      ctx = new AC(); out = ctx.createGain(); out.gain.value = 0.0001;
      var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 5000; var comp = ctx.createDynamicsCompressor(); comp.threshold.value = -16; comp.ratio.value = 4;
      verb = reverb(); var wet = ctx.createGain(); wet.gain.value = .6; verb.connect(wet); wet.connect(out);
      out.connect(lp); lp.connect(comp); comp.connect(ctx.destination);
      return true;
    }
    var hz = function (m) { return 440 * Math.pow(2, (m - 69) / 12); };
    /* Original score: slow and sparse. Soft felt piano over a low pad, 60 BPM, in D.
       Dmaj9 → Bm9 → Gmaj9 → A6sus. A quiet low pulse on each beat moves the heart monitor. */
    var BPM = 60, BEAT = 60 / BPM, nextT = 0, pos = 0, drive;
    var CH = [[50, 57, 62, 64, 66, 69], [47, 54, 61, 62, 66, 69], [43, 50, 57, 62, 66, 69], [45, 52, 59, 62, 64, 66]];
    var MEL = [74, 76, 78, 81, 83, 86];
    function env(g, t, a, peak, dec) { g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + a); g.gain.exponentialRampToValueAtTime(0.0001, t + a + dec); }
    function pulse(t, m) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(hz(m) * 1.8, t); o.frequency.exponentialRampToValueAtTime(hz(m), t + .06);
      env(g, t, .006, .22, .5); o.connect(g); g.connect(out); o.start(t); o.stop(t + .6);
      var ms = Math.max(0, (t - ctx.currentTime) * 1000);
      setTimeout(function () { if (!playing) return; document.querySelectorAll('[data-monitor]').forEach(function (mn) { if (mn.saTrigger) mn.saTrigger(); }); }, ms);
    }
    function piano(m, t, v, len) {
      var o = ctx.createOscillator(), o2 = ctx.createOscillator(), g = ctx.createGain(), f = ctx.createBiquadFilter(), g2 = ctx.createGain();
      o.type = 'triangle'; o.frequency.value = hz(m); o2.type = 'sine'; o2.frequency.value = hz(m) * 2.001; g2.gain.value = .18;
      f.type = 'lowpass'; f.frequency.setValueAtTime(2600, t); f.frequency.exponentialRampToValueAtTime(700, t + len);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(v, t + .008); g.gain.exponentialRampToValueAtTime(0.0001, t + len);
      o.connect(g); o2.connect(g2); g2.connect(g); g.connect(f); f.connect(out); f.connect(verb);
      o.start(t); o2.start(t); o.stop(t + len + .05); o2.stop(t + len + .05);
    }
    function pad(notes, t, len) {
      notes.slice(0, 4).forEach(function (m, i) {
        [-5, 5].forEach(function (det) {
          var o = ctx.createOscillator(), g = ctx.createGain(), f = ctx.createBiquadFilter();
          o.type = i ? 'triangle' : 'sine'; o.frequency.value = hz(m - (i ? 0 : 12)); o.detune.value = det;
          f.type = 'lowpass'; f.frequency.value = 800;
          g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(i ? .016 : .05, t + 2); g.gain.setValueAtTime(i ? .016 : .05, t + len - 1); g.gain.exponentialRampToValueAtTime(0.0001, t + len + 1.5);
          o.connect(f); f.connect(g); g.connect(out); g.connect(verb); o.start(t); o.stop(t + len + 1.6);
        });
      });
    }
    function stepAt(t, i) {
      var bar = Math.floor(i / 4) % 4, b = i % 4;
      pulse(t, CH[bar][0] - 24);
      if (b === 0) {
        pad(CH[bar], t, BEAT * 4);
        CH[bar].slice(2).forEach(function (m, k) { piano(m, t + k * .09, .05, 3.2); });
      }
      if (b === 2 && Math.random() < .75) piano(MEL[Math.floor(Math.random() * MEL.length)], t + (Math.random() < .5 ? 0 : BEAT / 2), .045, 2.6);
    }
    function schedule() {
      while (nextT < ctx.currentTime + .15) { stepAt(nextT, pos); nextT += BEAT; pos++; }
    }
    function fade(to, secs) { var now = ctx.currentTime; out.gain.cancelScheduledValues(now); out.gain.setValueAtTime(Math.max(out.gain.value, .0001), now); out.gain.exponentialRampToValueAtTime(Math.max(to, .0001), now + secs); }
    function startScore() {
      if (!setup()) return;
      if (ctx.state === 'suspended') ctx.resume();
      fade(vol * .9, 3);
      if (!timer) { nextT = ctx.currentTime + .1; pos = 0; schedule(); timer = setInterval(schedule, 25); }
    }
    function stopScore() { if (!ctx) return; fade(.0001, 1.6); clearInterval(timer); timer = null; }
    function startTrack() {
      if (!audio) {
        audio = new Audio(src); audio.loop = true; audio.preload = 'auto'; audio.volume = 0;
        try { var pos = parseFloat(sessionStorage.getItem('sa-music-pos')); if (pos > 0) audio.currentTime = pos; } catch (e) {}
        window.addEventListener('pagehide', function () { try { sessionStorage.setItem('sa-music-pos', String(audio.currentTime || 0)); } catch (e) {} });
      }
      var p = audio.play(); if (p && p.catch) p.catch(function () {});
      var v = 0, target = vol; clearInterval(audio._f); audio._f = setInterval(function () { v = Math.min(target, v + target / 30); audio.volume = v; if (v >= target) clearInterval(audio._f); }, 80);
    }
    function stopTrack() { if (!audio) return; clearInterval(audio._f); var v = audio.volume; audio._f = setInterval(function () { v = Math.max(0, v - .04); audio.volume = v; if (v <= 0) { clearInterval(audio._f); audio.pause(); } }, 60); }
    var baseSound = null;
    function set(on) {
      if (on === playing) return; playing = on;
      if (!src) {
        if (!baseSound) baseSound = window.saSound;
        window.saSound = on ? function (k) { if (k !== 'beat' && baseSound) return baseSound.apply(this, arguments); } : baseSound;
      }
      html.classList.toggle('sa-sound-on', on);
      if (src) { on ? startTrack() : stopTrack(); } else { on ? startScore() : stopScore(); }
    }
    toggles.forEach(function (b) {
      b.hidden = false;
      b.addEventListener('click', function () { setTimeout(function () { set(b.getAttribute('aria-pressed') === 'true'); }, 0); });
    });
    // Remembered "sound on": resume on the visitor's first tap or key, since browsers need a gesture
    if (read('sa-sound') === '1') {
      var resume = function (e) {
        if (e.target.closest && e.target.closest('[data-sound-toggle]')) return cleanup();
        var b = toggles[0]; if (b && b.getAttribute('aria-pressed') !== 'true') b.click();
        cleanup();
      };
      var cleanup = function () { ['pointerdown', 'keydown'].forEach(function (ev) { document.removeEventListener(ev, resume, true); }); };
      ['pointerdown', 'keydown'].forEach(function (ev) { document.addEventListener(ev, resume, true); });
    }
    document.addEventListener('visibilitychange', function () {
      if (!playing) return;
      if (document.hidden) { if (audio) audio.pause(); if (ctx) ctx.suspend(); }
      else { if (audio) audio.play().catch(function () {}); if (ctx) ctx.resume(); }
    });
  }

  /* ---------- Fit simulator ---------- */
  var FRACS = [[.12, 'a little of'], [.24, 'about a fifth of'], [.3, 'about a quarter of'], [.42, 'about a third of'], [9, 'almost half of']];
  function frac(x) { var s = '', a = Math.abs(x), w = Math.floor(a + 1e-6), r = a - w, q = Math.round(r * 4); if (q === 4) { w++; q = 0; } s = (w ? w : '') + ['', '¼', '½', '¾'][q]; return s || '0'; }
  function initFitSim(root) {
    $$('[data-fitsim]', root).forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var D; try { D = JSON.parse($('[data-fitsim-data]', box).textContent); } catch (e) { return; }
      var svg = $('[data-fitsim-svg]', box), gBody = $('[data-fitsim-body]', box), gJ = $('[data-fitsim-jacket]', box), gM = $('[data-fitsim-marks]', box);
      var ft = $('[data-fitsim-ft]', box), inch = $('[data-fitsim-in]', box), lb = $('[data-fitsim-lb]', box);
      var btns = $$('[data-fitsim-size]', box), idx = D.sizes.indexOf('L'), manual = false;
      var grad = svg.querySelector('linearGradient'); var leather = grad ? 'url(#' + grad.id + ')' : '#111';
      function P(x, y) { return x.toFixed(1) + ' ' + y.toFixed(1); }
      function trueSize(c) { for (var i = 0; i < D.fits.length; i++) if (c < D.fits[i][1]) return i; return D.fits.length - 1; }
      function run(animate) {
        var H = (parseFloat(ft.value) || 6) * 12 + (parseFloat(inch.value) || 0), W = parseFloat(lb.value) || 170;
        H = Math.max(56, Math.min(84, H)); W = Math.max(80, Math.min(400, W));
        var c = 0.15 * W + 12.5 * (H / 70) ;
        var rec = trueSize(c);
        if (!manual) idx = rec;
        btns.forEach(function (b, i) { b.setAttribute('aria-checked', i === idx ? 'true' : 'false'); b.classList.toggle('is-rec', i === rec); });
        // Body model (inches)
        var s = 520 / 84, cx = 160, top = 548 - H * s;
        var hps = 0.155 * H, belt = hps + 0.29 * H, arm = 0.325 * H, hand = 0.107 * H, biac = 0.22 * H, crotch = 0.535 * H;
        var ch = c * 0.39 / 2, wa = Math.max(ch - 1.6, (c - 6) * 0.39 / 2), hip = ch * 1.02;
        var Y = function (i) { return top + i * s; }, X = function (i) { return cx + i * s; };
        var sh = biac / 2, ay = hps + 1.1, wx = sh + 1.9, wy = ay + arm * 0.985;
        var head = 'M' + P(X(0), Y(0)) + ' C' + P(X(3.4), Y(0)) + ' ' + P(X(3.5), Y(8.4)) + ' ' + P(X(0), Y(8.9)) + ' C' + P(X(-3.5), Y(8.4)) + ' ' + P(X(-3.4), Y(0)) + ' ' + P(X(0), Y(0)) + 'Z';
        var torso = ['M', P(X(-2.3), Y(8.5)), 'L', P(X(2.3), Y(8.5)), 'L', P(X(2.4), Y(hps - .3)), 'Q', P(X(sh - .6), Y(hps - .2)), P(X(sh + .6), Y(ay)),
          'L', P(X(wx + 1.4), Y(wy)), 'L', P(X(wx + .1), Y(wy + .2)), 'L', P(X(ch - .3), Y(ay + 6)), 'Q', P(X(ch), Y(ay + 9)), P(X(wa), Y(belt - 1)), 'L', P(X(hip), Y(crotch)),
          'L', P(X(hip - .6), Y(H - .6)), 'L', P(X(1), Y(H - .6)), 'L', P(X(.6), Y(crotch + 1)), 'L', P(X(-.6), Y(crotch + 1)), 'L', P(X(-1), Y(H - .6)), 'L', P(X(-hip + .6), Y(H - .6)),
          'L', P(X(-hip), Y(crotch)), 'L', P(X(-wa), Y(belt - 1)), 'Q', P(X(-ch), Y(ay + 9)), P(X(-ch + .3), Y(ay + 6)), 'L', P(X(-wx - .1), Y(wy + .2)), 'L', P(X(-wx - 1.4), Y(wy)),
          'L', P(X(-sh - .6), Y(ay)), 'Q', P(X(-sh + .6), Y(hps - .2)), P(X(-2.4), Y(hps - .3)), 'Z'].join(' ');
        var hands = [1, -1].map(function (k) { var hx = X(k * (wx + .7)), hy = Y(wy + hand * .5); return '<ellipse cx="' + hx.toFixed(1) + '" cy="' + hy.toFixed(1) + '" rx="' + (1.6 * s).toFixed(1) + '" ry="' + (hand * .52 * s).toFixed(1) + '"/>'; }).join('');
        gBody.innerHTML = '<path d="' + head + '"/><path d="' + torso + '"/>' + hands + '<line class="sa-fitsim__belt" x1="' + X(-wa - 1.4).toFixed(1) + '" y1="' + Y(belt).toFixed(1) + '" x2="' + X(wa + 1.4).toFixed(1) + '" y2="' + Y(belt).toFixed(1) + '"/>';
        // Jacket (size idx)
        var L = D.length[idx], B = D.chest[idx], Sh = D.shoulder[idx], E = D.sleeve[idx], bi = D.bicep[idx], op = D.opening[idx];
        var drop = Math.max(0, Sh / 2 - biac / 2), dx = wx - sh, dy = wy - ay, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl;
        var sx = sh + ux * drop, sy = ay + uy * drop - .4, reach = E - 1.5, ex = sx + ux * reach, ey = sy + uy * reach;
        var jh = Math.max(B * 0.39 / 2, ch + 1.2), hemY = hps + L - 0.75, hemH = Math.max(jh - .6, (B - 2) * 0.39 / 2), nx = -uy, ny = ux;
        var tw = bi * 0.42, ew = op * 0.44;
        var body = ['M', P(X(-2.9), Y(hps - 1.2)), 'L', P(X(2.9), Y(hps - 1.2)), 'L', P(X(sx + nx * 0), Y(sy - .2)), 'L', P(X(jh), Y(ay + D.shoulder[idx] * 0 + 6.2)), 'L', P(X(hemH), Y(hemY)),
          'L', P(X(-hemH), Y(hemY)), 'L', P(X(-jh), Y(ay + 6.2)), 'L', P(X(-sx), Y(sy - .2)), 'Z'].join(' ');
        function sleeve(k) {
          var a1 = [k * (sx - nx * tw * .15), sy - ny * tw * .15], a2 = [k * (sx + nx * tw * 1.7), sy + ny * tw * 1.7], b2 = [k * (ex + nx * ew), ey + ny * ew], b1 = [k * (ex - nx * ew), ey - ny * ew];
          return 'M' + P(X(a1[0]), Y(a1[1])) + ' L' + P(X(a2[0]), Y(a2[1])) + ' L' + P(X(b2[0]), Y(b2[1])) + ' L' + P(X(b1[0]), Y(b1[1])) + 'Z';
        }
        var collar = 'M' + P(X(-2.9), Y(hps - 1.2)) + ' L' + P(X(-.2), Y(hps + 4.2)) + ' L' + P(X(-4.6), Y(hps + 2.2)) + 'Z M' + P(X(2.9), Y(hps - 1.2)) + ' L' + P(X(.2), Y(hps + 4.2)) + ' L' + P(X(4.6), Y(hps + 2.2)) + 'Z';
        gJ.innerHTML = '<path fill="' + leather + '" d="' + sleeve(1) + '"/><path fill="' + leather + '" d="' + sleeve(-1) + '"/><path fill="' + leather + '" d="' + body + '"/>' +
          '<path class="sa-fitsim__collar" d="' + collar + '"/>' +
          '<line class="sa-fitsim__zip" x1="' + X(0) + '" y1="' + Y(hps + 4).toFixed(1) + '" x2="' + X(0) + '" y2="' + Y(hemY).toFixed(1) + '"/>' +
          '<line class="sa-fitsim__band" x1="' + X(-hemH).toFixed(1) + '" y1="' + Y(hemY - 2.4).toFixed(1) + '" x2="' + X(hemH).toFixed(1) + '" y2="' + Y(hemY - 2.4).toFixed(1) + '"/>';
        // Readouts
        var dHem = belt - hemY, cover = (sy - ay) + reach - (drop * 0) - arm + (drop - (sy - ay)) , fr;
        cover = drop + reach - arm;
        var hemTxt = dHem > 1.5 ? 'about ' + frac(dHem) + '″ above your belt' : dHem >= 0 ? 'just above your belt' : dHem > -1 ? 'right at your belt' : 'about ' + frac(-dHem) + '″ below your belt';
        var slvTxt;
        if (cover < -0.5) slvTxt = 'end about ' + frac(-cover) + '″ above your wrist';
        else if (cover < 0.5) slvTxt = 'end right at your wrist';
        else { fr = cover / hand; var f = FRACS.filter(function (x) { return fr < x[0]; })[0][1]; slvTxt = 'cover your wrist and ' + f + ' your hand'; }
        var ease = B - c, easeTxt = ease >= 10 ? 'Boxy and oversized, as designed' : ease >= 6 ? 'Relaxed, a little less boxy' : 'Close through the chest. Size up for the full look';
        $('[data-fitsim-hem]', box).textContent = hemTxt.charAt(0).toUpperCase() + hemTxt.slice(1);
        $('[data-fitsim-sleeve]', box).textContent = slvTxt.charAt(0).toUpperCase() + slvTxt.slice(1);
        $('[data-fitsim-ease]', box).textContent = easeTxt + ' (' + Math.round(ease) + '″ of room)';
        var down = rec > 0 ? D.sizes[rec - 1] : null;
        $('[data-fitsim-rec]', box).innerHTML = 'Your usual size: <strong>' + D.sizes[rec] + '</strong>' + (down ? ' · for a truer fit: <strong>' + down + '</strong>' : '') + (manual && idx !== rec ? ' · showing ' + D.sizes[idx] : '');
        gM.innerHTML = '<text x="' + X(wa + 1.8).toFixed(1) + '" y="' + (Y(belt) + 3).toFixed(1) + '">belt</text>';
        if (animate && !reduce) { box.classList.remove('is-anim'); void box.offsetWidth; box.classList.add('is-anim'); }
      }
      [ft, inch].forEach(function (el) { el.addEventListener('change', function () { manual = false; run(true); }); });
      lb.addEventListener('input', function () { manual = false; run(false); });
      btns.forEach(function (b, i) { b.addEventListener('click', function () { idx = i; manual = true; run(true); if (window.saSound) window.saSound('turn'); }); });
      run(false);
    });
  }

  /* ---------- Sun & moon sleeves: drag to unzip ---------- */
  function initSleeves(root) {
    $$('[data-sleeves]', root).forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var stage = $('[data-zip-stage]', sec), svg = $('[data-zip-svg]', sec), range = $('[data-zip-range]', sec);
      var L = $('[data-zip-left]', sec), R = $('[data-zip-right]', sec), tl = $('[data-zip-teeth-l]', sec), tr = $('[data-zip-teeth-r]', sec), tc = $('[data-zip-teeth-c]', sec);
      var hemL = $('[data-zip-hem]', sec), stL = $('[data-zip-stitch]', sec), pull = $('[data-zip-pull]', sec), sun = $('[data-zip-sun]', sec), moon = $('[data-zip-moon]', sec), msg = $('[data-zip-msg]', sec), glow = $('[data-zip-glow]', sec), inches = $('[data-zip-inches]', sec);
      var TOP = 90, HEM = 560, CX = 200, p = 0, lastIn = 0, touched = false;
      function draw(v) {
        p = Math.max(0, Math.min(1, v));
        var y = HEM - p * (HEM - TOP), g = p > 0 ? 6 + 120 * p : 0;
        L.setAttribute('d', 'M0 0 H' + CX + ' V' + y.toFixed(1) + ' L' + (CX - g).toFixed(1) + ' 620 H0 Z');
        R.setAttribute('d', 'M400 0 H' + CX + ' V' + y.toFixed(1) + ' L' + (CX + g).toFixed(1) + ' 620 H400 Z');
        tc.setAttribute('d', 'M' + CX + ' ' + TOP + ' V' + y.toFixed(1));
        tl.setAttribute('d', 'M' + (CX - 3) + ' ' + y.toFixed(1) + ' L' + (CX - g - 3).toFixed(1) + ' 620');
        tr.setAttribute('d', 'M' + (CX + 3) + ' ' + y.toFixed(1) + ' L' + (CX + g + 3).toFixed(1) + ' 620');
        function seg(yy) { var w = yy > y ? g * (yy - y) / (620 - y) : 0; return w > 0.5 ? 'M0 ' + yy + ' H' + (CX - w).toFixed(1) + ' M' + (CX + w).toFixed(1) + ' ' + yy + ' H400' : 'M0 ' + yy + ' H400'; }
        if (hemL) hemL.setAttribute('d', seg(560)); if (stL) stL.setAttribute('d', seg(548));
        pull.setAttribute('transform', 'translate(' + CX + ' ' + (y - 20).toFixed(1) + ') scale(1.35)');
        glow.setAttribute('opacity', (p * .9).toFixed(2));
        msg.style.opacity = Math.max(0, (p - .25) / .5).toFixed(2);
        stage.style.setProperty('--p', p.toFixed(3));
        var inch = Math.round(p * 7 * 2) / 2; inches.textContent = String(inch).replace('.5', '½');
        if (Math.floor(p * 7) !== lastIn) { lastIn = Math.floor(p * 7); if (window.saSound && touched) window.saSound('turn'); }
        range.value = Math.round(p * 100);
        range.setAttribute('aria-valuetext', inch + ' of 7 inches open');
      }
      function yFrom(e) { var r = svg.getBoundingClientRect(); return (e.clientY - r.top) / r.height * 620; }
      var drag = false;
      svg.addEventListener('pointerdown', function (e) { drag = true; touched = true; stage.classList.add('is-drag'); svg.setPointerCapture(e.pointerId); draw((HEM - yFrom(e) + 16) / (HEM - TOP)); });
      svg.addEventListener('pointermove', function (e) { if (drag) draw((HEM - yFrom(e) + 16) / (HEM - TOP)); });
      ['pointerup', 'pointercancel'].forEach(function (ev) { svg.addEventListener(ev, function () { drag = false; stage.classList.remove('is-drag'); }); });
      range.addEventListener('input', function () { touched = true; draw(range.value / 100); });
      $$('[data-sleeves-side]', sec).forEach(function (t) {
        t.addEventListener('click', function () {
          var side = t.getAttribute('data-sleeves-side');
          $$('[data-sleeves-side]', sec).forEach(function (o) { var on = o === t; o.classList.toggle('is-active', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
          sun.setAttribute('display', side === 'sun' ? 'inline' : 'none'); moon.setAttribute('display', side === 'moon' ? 'inline' : 'none');
          msg.textContent = side === 'sun' ? 'the sun on your right.' : 'the moon on your left.';
          stage.setAttribute('data-side', side);
          if (window.saSound) window.saSound('chime');
        });
      });
      draw(0);
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting || touched) return; io.disconnect();
          var t0 = null;
          (function tick(t) { if (touched) return; if (!t0) t0 = t; var k = (t - t0) / 2600; if (k > 1) return draw(.18); var e = k < .55 ? Math.sin(k / .55 * Math.PI / 2) * .62 : .62 - (k - .55) / .45 * .44; draw(e); requestAnimationFrame(tick); })(performance.now());
        }, { threshold: .5 });
        io.observe(stage);
      }
    });
  }

  function boot(root) { initFitSim(root); initSleeves(root); }
  function start() { initGate(); initMusic(); boot(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  else setTimeout(start, 0);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
